/// <reference path="../../typings/index.d.ts" />
angular.module('app', [
    'ngRoute', 'ngResource',
    'ui.sortable', 'ngHolder', 'ngFileUpload', 'ui.bootstrap', 'bw.paging',
    'formly', 'formlyBootstrap', 'ipCookie',
    'app.config'
]);

angular.module("app.config", [])
.constant("API_BASE", "http://api.store-sandbox.thekono.com/api/v1")
.constant("TOKEN", "9f62194c35ce5f3d812ad66fb94063199b03916038615717");

/// <reference path="../../typings/index.d.ts" />
angular
    .module('app')
    .config(function ($routeProvider) {
    $routeProvider
        .when('/products', {
        templateUrl: 'app/products/index.html',
        controller: 'Products',
        controllerAs: 'vm'
    })
        .when('/products/create', {
        templateUrl: 'app/products/create.html',
        controller: 'CreateProduct',
        controllerAs: 'vm'
    })
        .when('/products/:productId/update', {
        templateUrl: 'app/products/update.html',
        controller: 'UpdateProduct',
        controllerAs: 'vm'
    })
        .when('/products/:productId/images', {
        templateUrl: 'app/products/images.html',
        controller: 'ProductImages',
        controllerAs: 'vm'
    })
        .when('/products/:productId/properties', {
        templateUrl: 'app/products/properties.html',
        controller: 'ProductProperties',
        controllerAs: 'vm'
    })
        .when('/products/:productId/stocks', {
        templateUrl: 'app/products/stocks.html',
        controller: 'ProductStocks',
        controllerAs: 'vm'
    })
        .when('/orders', {
        templateUrl: 'app/orders/index.html',
        controller: 'Orders',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/cart', {
        templateUrl: 'app/orders/cart.html',
        controller: 'Cart',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/customer', {
        templateUrl: 'app/orders/customer.html',
        controller: 'OrderCustomer',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/payments', {
        templateUrl: 'app/orders/payments.html',
        controller: 'OrderPayments',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/shipments', {
        templateUrl: 'app/orders/shipments.html',
        controller: 'OrderShipments',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/adjustments', {
        templateUrl: 'app/orders/adjustments.html',
        controller: 'OrderAdjustments',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/rmas', {
        templateUrl: 'app/orders/rmas.html',
        controller: 'OrderRMAs',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/rmas/new', {
        templateUrl: 'app/orders/create-rma.html',
        controller: 'CreateRMA',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/rmas/:id', {
        templateUrl: 'app/orders/update-rma.html',
        controller: 'UpdateRMA',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/customer_returns', {
        templateUrl: 'app/orders/customer-returns.html',
        controller: 'OrderCustomerReturns',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/customer_returns/new', {
        templateUrl: 'app/orders/create-customer-return.html',
        controller: 'CreateCustomerReturn',
        controllerAs: 'vm'
    })
        .when('/orders/:orderNum/customer_returns/:id', {
        templateUrl: 'app/orders/customer-return.html',
        controller: 'CustomerReturn',
        controllerAs: 'vm'
    })
        .when('/promotions', {
        templateUrl: 'app/promotions/index.html',
        controller: 'Promotions',
        controllerAs: 'vm'
    })
        .when('/promotions/create', {
        templateUrl: 'app/promotions/create.html',
        controller: 'CreatePromotion',
        controllerAs: 'vm'
    })
        .when('/promotions/:id', {
        templateUrl: 'app/promotions/update.html',
        controller: 'UpdatePromotion',
        controllerAs: 'vm'
    })
        .when('/users', {
        templateUrl: 'app/users/index.html',
        controller: 'Users',
        controllerAs: 'vm'
    })
        .when('/users/:id', {
        templateUrl: 'app/users/update.html',
        controller: 'UpdateUser',
        controllerAs: 'vm'
    })
        .otherwise({ redirectTo: '/products' });
})
    .config(function ($httpProvider) {
    $httpProvider.interceptors.push(function ($q, AuthService) {
        return {
            request: function (config) {
                if (AuthService.isAuthenticated()) {
                    config.headers['X-Spree-Token'] = AuthService.user().token;
                }
                // disable IE ajax request caching
                config.headers['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                config.headers['Cache-Control'] = 'no-cache';
                return config;
            },
            response: function (resp) {
                if (resp.status === 401) {
                    AuthService.forget();
                }
                return resp;
            },
            responseError: function (rejection) {
                if (rejection.status === 401) {
                    AuthService.forget();
                }
                return $q.reject(rejection);
            }
        };
    });
});

/// <reference path="../../../typings/index.d.ts" />
function AuthService(ipCookie) {
    var _user = null;
    return {
        user: function () {
            if (!_user) {
                _user = ipCookie('auth');
            }
            return _user;
        },
        canLogin: function (user) {
            return user && user.admin && !!user.token;
        },
        isAuthenticated: function () {
            var user = this.user();
            return user && this.canLogin(user);
        },
        memorize: function (user) {
            _user = user;
            ipCookie('auth', user, { expires: 1 }); // 1 day long
        },
        forget: function () {
            ipCookie.remove('auth');
            _user = null;
        }
    };
}
angular
    .module('app')
    .factory('AuthService', AuthService);

/// <reference path="../../../typings/index.d.ts" />
function CalculatorService() {
    var FLAT_RATE_CALCULATOR = 'Spree::Calculator::FlatRate';
    var FLAT_PERCENT_CALCULATOR = 'Spree::Calculator::FlatPercentItemTotal';
    var CALCULATORS = [
        FLAT_RATE_CALCULATOR,
        FLAT_PERCENT_CALCULATOR
    ];
    var nameLut = {};
    nameLut[FLAT_RATE_CALCULATOR] = 'Flat rate';
    nameLut[FLAT_PERCENT_CALCULATOR] = 'Flat percent';
    return {
        FLAT_RATE_CALCULATOR: FLAT_RATE_CALCULATOR,
        FLAT_PERCENT_CALCULATOR: FLAT_PERCENT_CALCULATOR,
        CALCULATORS: CALCULATORS,
        name: function (type) { return nameLut[type]; }
    };
}
angular
    .module('app')
    .factory('CalculatorService', CalculatorService);

/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../modules/resource/order.ts" />
/// <reference path="../modules/api/order.ts" />
"use strict";
angular
    .module('app')
    .factory('OrderResource', function ($resource, API_BASE) {
    var indexAction = {
        method: 'GET',
        isArray: false
    };
    var res = $resource(API_BASE + "/orders/:number", { number: '@number' }, { index: indexAction });
    angular.extend(res.prototype, gladiator.resource.Order.prototype);
    return res;
});

/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../modules/resource/product.ts" />
/// <reference path="../modules/api/product.ts" />
"use strict";
angular
    .module('app')
    .factory('ProductResource', function ($resource, API_BASE) {
    var indexAction = {
        method: 'GET',
        isArray: false
    };
    var res = $resource(API_BASE + "/products/:id", { id: '@id' }, { index: indexAction });
    angular.extend(res.prototype, gladiator.resource.Product.prototype);
    return res;
});

/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../modules/api/shipping_category.ts" />
"use strict";
angular
    .module('app')
    .factory('ShippingCategoryResource', function ($resource, API_BASE) {
    var res = $resource(API_BASE + "/shipping_categories/:id", { id: '@id' }, {
        query: {
            method: 'GET',
            isArray: true,
            transformResponse: function (data) {
                return angular.fromJson(data).shipping_categories;
            }
        }
    });
    return res;
});

/// <reference path="../../../typings/index.d.ts" />
angular
    .module('app')
    .component('alert', {
    templateUrl: 'app/components/alert.html',
    bindings: {
        error: '<'
    }
});

/// <reference path="../../../typings/index.d.ts" />
function ApproveOrderCtrl(API_BASE, $http) {
    var $ctrl = this;
    $ctrl.isLoading = true;
    $ctrl.isApproving = false;
    $ctrl.approval = null;
    $ctrl.$onChanges = function () {
        if ($ctrl.orderNum) {
            $ctrl.isLoading = true;
            loadApproval();
        }
    };
    $ctrl.approve = function () {
        $ctrl.isApproving = true;
        $http
            .put(API_BASE + "/orders/" + $ctrl.orderNum + "/approve", {})
            .then(onApproveSuccess);
    };
    function loadApproval() {
        $http
            .get(API_BASE + "/orders/" + $ctrl.orderNum + "/approval")
            .then(onLoadSuccess);
    }
    function onLoadSuccess(resp) {
        $ctrl.approval = resp.data;
        $ctrl.isLoading = false;
        $ctrl.isApproving = false;
    }
    function onApproveSuccess() {
        loadApproval();
    }
}
angular
    .module('app')
    .component('approveOrder', {
    templateUrl: 'app/components/approve-order.html',
    bindings: {
        orderNum: '<'
    },
    controller: ApproveOrderCtrl
});

/// <reference path="../../../typings/index.d.ts" />
function AuthMenuCtrl(AuthService) {
    var $ctrl = this;
    $ctrl.email = function () {
        var user = AuthService.user();
        return user ? user.email : '';
    };
    $ctrl.logout = function () {
        AuthService.forget();
    };
}
angular
    .module('app')
    .component('authMenu', {
    templateUrl: 'app/components/auth-menu.component.html',
    bindings: {},
    controller: AuthMenuCtrl
});

/// <reference path="../../../typings/index.d.ts" />
angular
    .module('app')
    .component('createProductImageComponent', {
    templateUrl: 'app/components/create-product-image.html',
    bindings: {
        close: '&',
        dismiss: '&'
    },
    controller: function () {
        var $ctrl = this;
        $ctrl.$onInit = function () {
            $ctrl.files = [];
        };
        $ctrl.ok = function () { $ctrl.close({ $value: $ctrl.files }); };
        $ctrl.cancel = function () { $ctrl.dismiss(); };
    }
});

/// <reference path="../../../typings/index.d.ts" />
function LoginCtrl(API_BASE, $http, AuthService) {
    var $ctrl = this;
    $ctrl.email = null;
    $ctrl.password = null;
    $ctrl.isLoading = false;
    $ctrl.error = false;
    $ctrl.login = function () {
        var params = {
            user: {
                platform: 'kono', account: $ctrl.email, validator: $ctrl.password
            }
        };
        $ctrl.isLoading = true;
        $ctrl.error = false;
        $http
            .post(API_BASE + "/users/signin", params)
            .then(onSuccessLogin, onErrorLogin)
            .finally(function () { return $ctrl.isLoading = false; });
    };
    function onSuccessLogin(resp) {
        var user = resp.data;
        if (AuthService.canLogin(user)) {
            AuthService.memorize(user);
            return;
        }
        onErrorLogin();
    }
    function onErrorLogin() {
        $ctrl.error = true;
    }
}
angular
    .module('app')
    .component('login', {
    templateUrl: 'app/components/login.html',
    bindings: {},
    controller: LoginCtrl
});

/// <reference path="../../../typings/index.d.ts" />
function MainSidebarController($location) {
    var $ctrl = this;
    this.isActive = function (name) {
        var url = $location.url();
        return url.startsWith("/" + name);
    };
}
angular
    .module('app')
    .component('mainSidebar', {
    templateUrl: 'app/components/main-sidebar.html',
    controller: MainSidebarController
});

/// <reference path="../../../typings/index.d.ts" />
function NavbarCtrl(AuthService) {
    var $ctrl = this;
    $ctrl.isAuthenticated = function () { return AuthService.isAuthenticated(); };
}
angular
    .module('app')
    .component('navbar', {
    templateUrl: 'app/components/navbar.html',
    controller: NavbarCtrl
});

/// <reference path="../../../typings/index.d.ts" />
angular
    .module('app')
    .component('orderDetailMenu', {
    templateUrl: 'app/components/order-detail-menu.html',
    bindings: {
        active: '<',
        orderNum: '<'
    }
});

/// <reference path="../../../typings/index.d.ts" />
function ProductAvailabilityController() {
    var ctrl = this;
    ctrl.labelClass = function () {
        var cls = 'label-default';
        if (!ctrl.product) {
            return cls;
        }
        if (this.product.isDiscontinued() || this.product.isDeleted()) {
            cls = 'label-danger';
        }
        else if (this.product.isAvailable()) {
            cls = 'label-success';
        }
        return cls;
    };
}
angular
    .module('app')
    .component('productAvailability', {
    templateUrl: 'app/components/product-availability.html',
    controller: ProductAvailabilityController,
    bindings: {
        product: '<'
    }
});

/// <reference path="../../../typings/index.d.ts" />
angular
    .module('app')
    .component('productDetailMenu', {
    templateUrl: 'app/components/product-detail-menu.html',
    bindings: {
        active: '<',
        productId: '<'
    }
});

/// <reference path="../../../typings/index.d.ts" />
function PromotionActionCalculatorCtrl(CalculatorService) {
    var $ctrl = this;
    $ctrl.availableCalculatorOptions = _.map($ctrl.availableCalculators, function (type) {
        return { type: type, name: CalculatorService.name(type) };
    });
    $ctrl.name = function () {
        if ($ctrl.calculator) {
            return CalculatorService.name($ctrl.calculator.type);
        }
        return null;
    };
    $ctrl.isFlatRate = function () {
        return $ctrl.calculator.type === CalculatorService.FLAT_RATE_CALCULATOR;
    };
    $ctrl.isFlatPercent = function () {
        return $ctrl.calculator.type === CalculatorService.FLAT_PERCENT_CALCULATOR;
    };
    $ctrl.reset = function () {
        var keys = _.keys($ctrl.calculator);
        _.each(keys, function (key) { return key !== 'id' && key !== 'type' && (delete $ctrl.calculator[key]); });
        if ($ctrl.isFlatRate()) {
            $ctrl.calculator.preferred_amount = '100';
        }
        else if ($ctrl.isFlatPercent()) {
            $ctrl.calculator.preferred_flat_percent = '10';
        }
    };
}
angular
    .module('app')
    .component('promotionActionCalculator', {
    templateUrl: 'app/components/promotion-action-calculator.html',
    controller: PromotionActionCalculatorCtrl,
    bindings: {
        calculator: '<',
        availableCalculators: '<'
    }
});

/// <reference path="../../../typings/index.d.ts" />
function PromotionActionCtrl(CalculatorService) {
    var $ctrl = this;
    var AVAILABLE_CALCULATORS = {
        'Spree::Promotion::Actions::CreateAdjustment': [
            CalculatorService.FLAT_RATE_CALCULATOR,
            CalculatorService.FLAT_PERCENT_CALCULATOR
        ]
    };
    $ctrl.destroy = function () {
        $ctrl.action._destroy = true;
    };
    $ctrl.availableCalculators = function () {
        // must return the same array, otherwise, angular will determine the model
        // is different on each $digest cycle, and result in the error
        return AVAILABLE_CALCULATORS[$ctrl.action.type] || [];
    };
    $ctrl.calculatorName = function () {
        if ($ctrl.action && $ctrl.action.calculator) {
            return CalculatorService.name($ctrl.action.calculator.type);
        }
        return null;
    };
}
angular
    .module('app')
    .component('promotionAction', {
    templateUrl: 'app/components/promotion-action.html',
    controller: PromotionActionCtrl,
    bindings: {
        action: '<'
    }
});

/// <reference path="../../../typings/index.d.ts" />
function PromotionEditorController() {
    var $ctrl = this;
    $ctrl.fields = [
        {
            key: 'name',
            type: 'input',
            templateOptions: {
                label: 'Name',
                placeholder: 'required',
                required: true,
                description: 'Name is required'
            }
        },
        {
            key: 'description',
            type: 'textarea',
            className: 'u-formly-vertical-resize',
            templateOptions: {
                label: 'Description',
                rows: 3
            }
        },
        {
            key: 'code',
            type: 'input',
            templateOptions: {
                label: 'Code'
            }
        },
        {
            key: 'usage_limit',
            type: 'input',
            ngModelElAttrs: {
                'string-to-number': ''
            },
            templateOptions: {
                label: 'Usage limit' + ($ctrl.promotion.id ? " (Current usage: " + $ctrl.promotion.credits_count + ")" : ''),
                type: 'number',
                min: 1,
                description: 'Should be > 1'
            }
        },
        {
            key: 'starts_at',
            type: 'input',
            ngModelElAttrs: {
                'string-to-date': ''
            },
            templateOptions: {
                label: 'Start at',
                type: 'datetime-local'
            }
        },
        {
            key: 'expires_at',
            type: 'input',
            ngModelElAttrs: {
                'string-to-date': ''
            },
            templateOptions: {
                label: 'Expire at',
                type: 'datetime-local'
            }
        },
    ];
}
angular
    .module('app')
    .component('promotionEditor', {
    templateUrl: 'app/components/promotion-editor.html',
    controller: PromotionEditorController,
    bindings: {
        promotion: '<'
    }
});

/// <reference path="../../../typings/index.d.ts" />
function PromotionRuleCtrl() {
    var $ctrl = this;
    $ctrl.destroy = function () {
        $ctrl.rule._destroy = true;
    };
}
angular
    .module('app')
    .component('promotionRule', {
    templateUrl: 'app/components/promotion-rule.html',
    controller: PromotionRuleCtrl,
    bindings: {
        rule: '<'
    }
});

/// <reference path="../../../typings/index.d.ts" />
angular
    .module('app')
    .component('simpleBoolModalComponent', {
    templateUrl: 'app/components/simple-bool-modal.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    controller: function () {
        var $ctrl = this;
        $ctrl.yes = function () { $ctrl.close({ $value: true }); };
        $ctrl.no = function () { $ctrl.close({ $value: false }); };
    }
});

/// <reference path="../../../typings/index.d.ts" />
var UploadingStatus;
(function (UploadingStatus) {
    UploadingStatus[UploadingStatus["NOT_START_YET"] = 0] = "NOT_START_YET";
    UploadingStatus[UploadingStatus["UPLOADING"] = 1] = "UPLOADING";
    UploadingStatus[UploadingStatus["FAIL"] = 2] = "FAIL";
    UploadingStatus[UploadingStatus["SUCCESS"] = 3] = "SUCCESS";
})(UploadingStatus || (UploadingStatus = {}));
var UploadingFile = (function () {
    function UploadingFile(file) {
        this.file = file;
        this.uploadedSize = 0;
        this.status = UploadingStatus.NOT_START_YET;
        this.s3Key = null;
    }
    UploadingFile.prototype.size = function () {
        return this.file.size;
    };
    UploadingFile.prototype.start = function () {
        this.status = UploadingStatus.UPLOADING;
    };
    UploadingFile.prototype.ok = function () {
        this.status = UploadingStatus.SUCCESS;
        this.uploadedSize = this.file.size;
    };
    UploadingFile.prototype.fail = function () {
        this.status = UploadingStatus.FAIL;
    };
    return UploadingFile;
}());
function UploadPictureProgressController(API_BASE, $http, $window, Upload) {
    var $ctrl = this;
    $ctrl.uploadingFiles = [];
    $ctrl.$onChanges = function (changesObj) {
        if (!changesObj.files) {
            return;
        }
        $ctrl.uploadingFiles = $ctrl.files.map(function (file) { return new UploadingFile(file); });
        if ($ctrl.uploadingFiles.length !== 0) {
            upload();
        }
    };
    $ctrl.totalSize = function () {
        var cb = function (previousVal, uf) { return previousVal + uf.size(); };
        return $ctrl.uploadingFiles.reduce(cb, 0);
    };
    $ctrl.uploadedSize = function () {
        var cb = function (previousVal, uf) { return previousVal + uf.uploadedSize; };
        return $ctrl.uploadingFiles.reduce(cb, 0);
    };
    $ctrl.readableUploadedSize = function () {
        return $window.filesize($ctrl.uploadedSize());
    };
    $ctrl.uploadedPercentage = function () {
        if ($ctrl.totalSize() === 0) {
            return 0;
        }
        return (Math.min(1, $ctrl.uploadedSize() / $ctrl.totalSize()) * 100);
    };
    $ctrl.isUploading = function () {
        for (var i = 0; i < $ctrl.uploadingFiles.length; i++) {
            if ($ctrl.uploadingFiles[i].status === UploadingStatus.UPLOADING) {
                return true;
            }
        }
        return false;
    };
    $ctrl.isSuccess = function () {
        for (var i = 0; i < $ctrl.uploadingFiles.length; i++) {
            if ($ctrl.uploadingFiles[i].status !== UploadingStatus.SUCCESS) {
                return false;
            }
        }
        return true;
    };
    $ctrl.hasError = function () {
        for (var i = 0; i < $ctrl.uploadingFiles.length; i++) {
            if ($ctrl.uploadingFiles[i].status === UploadingStatus.FAIL) {
                return true;
            }
        }
        return false;
    };
    function upload() {
        angular.forEach($ctrl.uploadingFiles, function (uf) {
            getS3PresignedData().then(function (resp) { uploadFileToS3(uf, resp.data); }, function (resp) {
                uf.fail();
                tryComplete();
            });
        });
    }
    function getS3PresignedData() {
        return $http.get(API_BASE + "/pictures/presigned_form");
    }
    function uploadFileToS3(uf, resp) {
        uf.s3Key = resp.data.key;
        uf.start();
        resp.data.file = uf.file;
        Upload
            .upload(angular.extend({ method: 'POST' }, resp))
            .then(function (resp) { onUploadToS3(uf, resp); }, function (resp) { onUploadToS3Error(uf, resp); }, function (e) { onProgress(uf, e); });
    }
    function onUploadToS3(uf, resp) {
        createPicture(uf);
        console.log(resp.config.data.file.name + " is uploaded to s3");
    }
    function onUploadToS3Error(uf, resp) {
        uf.fail();
        tryComplete();
    }
    function onProgress(uf, e) {
        uf.uploadedSize = Math.min(e.loaded, e.total * 0.99);
    }
    function createPicture(uf) {
        var body = {
            picture: {
                key: uf.s3Key,
                alt: '',
                position: (new Date()).getTime() / 1000,
                viewable_type: gladiator.resource.Picture.VIEWABLE_TYPE,
                viewable_id: $ctrl.viewableId,
                type: gladiator.resource.Picture.BASE_TYPE
            }
        };
        $http
            .post(API_BASE + "/products/" + $ctrl.productId + "/pictures", body)
            .then(function (resp) {
            uf.ok();
            $ctrl.onCreate({ resp: resp });
            tryComplete();
        }, function (resp) {
            uf.fail();
            tryComplete();
        });
    }
    function isUploadingFinished() {
        for (var i = 0; i < $ctrl.uploadingFiles; i++) {
            var uf = $ctrl.uploadingFiles[i];
            if (uf.isUploading) {
                return false;
            }
        }
        return true;
    }
    function tryComplete() {
        if (isUploadingFinished()) {
            $ctrl.onComplete();
        }
    }
}
angular
    .module('app')
    .component('uploadPictureProgress', {
    templateUrl: 'app/components/upload-picture-progress.html',
    bindings: {
        files: '<',
        productId: '<',
        viewableId: '<',
        onCreate: '&',
        onComplete: '&'
    },
    controller: UploadPictureProgressController
});

/// <reference path="../../../typings/index.d.ts" />
angular
    .module('app')
    .component('userDetailMenu', {
    templateUrl: 'app/components/user-detail-menu.html',
    bindings: {
        active: '<',
        userId: '<'
    }
});













var gladiator;
(function (gladiator) {
    var resource;
    (function (resource) {
        var Order = (function () {
            function Order() {
            }
            return Order;
        }());
        resource.Order = Order;
    })(resource = gladiator.resource || (gladiator.resource = {}));
})(gladiator || (gladiator = {}));

var gladiator;
(function (gladiator) {
    var resource;
    (function (resource) {
        var Picture = (function () {
            function Picture() {
            }
            Picture.prototype.getType = function () {
                if (this.type === Picture.BASE_TYPE) {
                    return 'Base image';
                }
                if (this.type === Picture.MEDIA_TYPE) {
                    return 'Media image';
                }
                return '';
            };
            Picture.prototype.editPath = function () {
                return "#/pictures/" + this.id + "/update";
            };
            Picture.prototype.thumbnailUrl = function () {
                return this.images['150x150'].url;
            };
            Picture.VIEWABLE_TYPE = 'Spree::Variant';
            Picture.BASE_TYPE = 'PRODUCT_BASE';
            Picture.MEDIA_TYPE = 'PRODUCT_MEDIA';
            return Picture;
        }());
        resource.Picture = Picture;
    })(resource = gladiator.resource || (gladiator.resource = {}));
})(gladiator || (gladiator = {}));

var gladiator;
(function (gladiator) {
    var resource;
    (function (resource) {
        var Product = (function () {
            function Product() {
            }
            Product.prototype.availableOn = function () {
                if (!this.available_on) {
                    return null;
                }
                return new Date(this.available_on);
            };
            Product.prototype.isAvailable = function () {
                var now = new Date();
                var availableOn = this.availableOn();
                if (!availableOn) {
                    return false;
                }
                if (availableOn.getTime() > now.getTime()) {
                    return false;
                }
                if (this.isDeleted()) {
                    return false;
                }
                if (this.isDiscontinued()) {
                    return false;
                }
                return true;
            };
            Product.prototype.isDiscontinued = function () {
                if (!this.discontinue_on) {
                    return false;
                }
                var now = new Date();
                return Date.parse(this.discontinue_on) <= now.getTime();
            };
            Product.prototype.isDeleted = function () {
                return !!this.deleted_at;
            };
            Product.prototype.isPending = function () {
                var now = new Date();
                var availableOn = this.availableOn();
                return (availableOn && availableOn.getTime() > now.getTime());
            };
            Product.prototype.availableStatus = function () {
                if (this.isDiscontinued()) {
                    return 'Discontinued';
                }
                if (this.isDeleted()) {
                    return 'Deleted';
                }
                if (this.isAvailable()) {
                    return 'Available';
                }
                if (this.isPending()) {
                    return 'Pending Sale';
                }
                return 'No available date set';
            };
            Product.prototype.editPath = function (prefix) {
                if (!prefix) {
                    prefix = '';
                }
                return prefix + "/products/" + this.id + "/update";
            };
            Product.prototype.createImagePath = function (prefix) {
                if (!prefix) {
                    prefix = '';
                }
                return prefix + "/products/" + this.id + "/images/create";
            };
            return Product;
        }());
        resource.Product = Product;
    })(resource = gladiator.resource || (gladiator.resource = {}));
})(gladiator || (gladiator = {}));

var gladiator;
(function (gladiator) {
    var resource;
    (function (resource) {
        var Variant = (function () {
            function Variant() {
            }
            Variant.prototype.editPath = function () {
                return "#/variants/" + this.id + "/update";
            };
            return Variant;
        }());
        resource.Variant = Variant;
    })(resource = gladiator.resource || (gladiator.resource = {}));
})(gladiator || (gladiator = {}));





angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/alert.html","<div class=\"alert-component\">\n  <div class=\"alert alert-danger\" ng-if=\"$ctrl.error\">\n    <pre class=\"has-no-border has-no-bg\">{{$ctrl.error | json}}</pre>\n  </div>\n</div>");
$templateCache.put("app/components/approve-order.html","<div class=\"approve-order\">\n  <div class=\"text-center\" ng-show=\"$ctrl.isLoading\">\n    <img src=\"image/loading.gif\" class=\"approve-order__loading-icon\">\n  </div>\n\n  <div ng-hide=\"$ctrl.isLoading\">\n    <div ng-if=\"$ctrl.approval.can_approve\">\n      <button class=\"btn btn-primary btn-block approve-order__approve-btn\" ng-click=\"$ctrl.approve()\" ng-disabled=\"$ctrl.isApproving\">\n        <span ng-if=\"!$ctrl.isApproving\">\n          <span class=\"glyphicon glyphicon-ok\"></span> Approve\n        </span>\n        <span ng-if=\"$ctrl.isApproving\">Approving...</span>\n      </button>\n    </div>\n\n    <div class=\"alert alert-success\" ng-if=\"$ctrl.approval.approver\">\n      Approved by<br>\n      <strong ng-bind=\"$ctrl.approval.approver.email\"></strong>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/components/auth-menu.component.html","<span uib-dropdown on-toggle=\"$ctrl.toggle(open)\">\n  <a style=\"color: white; text-decoration: none; background-color: transparent\" href uib-dropdown-toggle>\n    <span class=\"glyphicon glyphicon-user\"></span>\n    <span class=\"caret\"></span>\n  </a>\n  <ul class=\"dropdown-menu\" style=\"margin-top: 15px\" uib-dropdown-menu aria-labelledby=\"auth menu\">\n    <li>\n      <a style=\"background-color: transparent\">\n        Signed in as<br>\n        <strong ng-bind=\"$ctrl.email()\"></strong>\n      </a>\n    </li>\n    <li role=\"separator\" class=\"divider\"></li>\n    <li>\n      <a href ng-click=\"$ctrl.logout()\">Sign out</a>\n    </li>\n  </ul>\n</span>");
$templateCache.put("app/components/create-product-image.html","<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">Upload - Select files</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <div class=\"jumbotron\" style=\"border: 5px dashed #DDD\" ngf-select ngf-drop ngf-multiple=\"true\" ng-model=\"$ctrl.files\" ngf-accept=\"\'image/*\'\">\n    <h2 class=\"text-center\">Select files or drop files</h2>\n  </div>\n\n  <ul class=\"list-group\">\n    <li class=\"list-group-item\" ng-repeat=\"file in $ctrl.files\">\n      {{file.name}}\n      <a class=\"close pull-right\" aria-label=\"Close\" ng-click=\"$ctrl.files.splice($index, 1)\">\n        &times;\n      </a>\n      <div class=\"clearfix\"></div>\n    </li>\n  </ul>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">Upload</button>\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n</div>\n");
$templateCache.put("app/components/login.html","<div class=\"row\">\n  <div class=\"col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-body\">\n        <form ng-submit=\"$ctrl.login()\">\n          <div class=\"form-group\">\n            <label>Email</label>\n            <input type=\"email\" class=\"form-control\" ng-model=\"$ctrl.email\">\n          </div>\n          <div class=\"form-group\">\n            <label>Password</label>\n            <input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.password\">\n          </div>\n          <button class=\"btn btn-success btn-block\" ng-disabled=\"$ctrl.isLoading\">\n            <span ng-if=\"!$ctrl.isLoading\">Sign in</span>\n            <span ng-if=\"$ctrl.isLoading\">Signing in...</span>\n          </button>\n        </form>\n      </div>\n    </div>\n\n    <div class=\"alert alert-danger\" ng-if=\"$ctrl.error\">\n      Incorrect username or password.\n    </div>\n  </div>\n</div>");
$templateCache.put("app/components/main-sidebar.html","<div class=\"main-sidebar panel panel-default\">\n  <div class=\"panel-heading\">\n    <h3 class=\"panel-title\">Admin</h3>\n  </div>\n\n  <table class=\"table\">\n    <tr class=\"main-sidebar__item\" ng-class=\"{\'main-sidebar__item__selected\': $ctrl.isActive(\'products\')}\">\n      <td>\n        <a class=\"main-sidebar__link\" href=\"#/products\" ng-class=\"{\'main-sidebar__link__selected\': $ctrl.isActive(\'products\')}\">Products</a>\n      </td>\n    </tr>\n    <tr class=\"main-sidebar__item\" ng-class=\"{\'main-sidebar__item__selected\': $ctrl.isActive(\'orders\')}\">\n      <td>\n        <a class=\"main-sidebar__link\" href=\"#/orders\" ng-class=\"{\'main-sidebar__link__selected\': $ctrl.isActive(\'orders\')}\">Orders</a>\n      </td>\n    </tr>\n    <tr class=\"main-sidebar__item\" ng-class=\"{\'main-sidebar__item__selected\': $ctrl.isActive(\'promotions\')}\">\n      <td>\n        <a class=\"main-sidebar__link\" href=\"#/promotions\" ng-class=\"{\'main-sidebar__link__selected\': $ctrl.isActive(\'promotions\')}\">Promotions</a>\n      </td>\n    </tr>\n    <tr class=\"main-sidebar__item\" ng-class=\"{\'main-sidebar__item__selected\': $ctrl.isActive(\'users\')}\">\n      <td>\n        <a class=\"main-sidebar__link\" href=\"#/users\" ng-class=\"{\'main-sidebar__link__selected\': $ctrl.isActive(\'users\')}\">Users</a>\n      </td>\n    </tr>\n  </table>\n</div>");
$templateCache.put("app/components/navbar.html","<nav class=\"navbar-component navbar navbar-fixed-top\">\n  <div class=\"container\">\n    <div class=\"navbar-header\">\n      <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\">\n        <span class=\"sr-only\">Toggle navigation</span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n      </button>\n      <a class=\"navbar-brand\" href=\"#\">\n        <img alt=\"Brand\" src=\"image/kono-logo-square.png\">\n      </a>\n    </div>\n    <div class=\"navbar-collapse collapse\" ng-if=\"$ctrl.isAuthenticated()\">\n      <ul class=\"nav navbar-nav navbar-right\">\n        <li style=\"padding-top: 15px; padding-bottom: 15px\">\n          <auth-menu></auth-menu>\n        </li>\n      </ul>\n<!--\n      <form class=\"navbar-form navbar-right\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"Search...\">\n      </form>\n-->\n    </div>\n  </div>\n</nav>\n");
$templateCache.put("app/components/order-detail-menu.html","<div class=\"list-group\">\n  <a ng-href=\"#/orders/{{$ctrl.orderNum}}/cart\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'cart\'}\">\n    Cart\n  </a>\n  <a ng-href=\"#/orders/{{$ctrl.orderNum}}/customer\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'customer\'}\">\n    Customer\n  </a>\n  <a ng-href=\"#/orders/{{$ctrl.orderNum}}/payments\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'payments\'}\">\n    Payments\n  </a>\n  <a ng-href=\"#/orders/{{$ctrl.orderNum}}/shipments\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'shipments\'}\">\n    Shipments\n  </a>\n  <a ng-href=\"#/orders/{{$ctrl.orderNum}}/adjustments\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'adjustments\'}\">\n    Adjustments\n  </a>\n  <a ng-href=\"#/orders/{{$ctrl.orderNum}}/rmas\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'rmas\'}\">\n    Return Authorizations\n  </a>\n  <a ng-href=\"#/orders/{{$ctrl.orderNum}}/customer_returns\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'customer_returns\'}\">\n    Customer Returns\n  </a>\n</div>\n");
$templateCache.put("app/components/product-availability.html","<span class=\"label {{$ctrl.labelClass()}}\" ng-bind=\"$ctrl.product.availableStatus()\"></span>");
$templateCache.put("app/components/product-detail-menu.html","<div class=\"list-group\">\n  <a ng-href=\"#/products/{{$ctrl.productId}}/update\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'detail\'}\">\n    Detail\n  </a>\n  <a ng-href=\"#/products/{{$ctrl.productId}}/images\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'images\'}\">\n    Images\n  </a>\n  <!--\n  <a ng-href=\"#/products/{{$ctrl.productId}}/variants\"\n     class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'variants\'}\">\n    Variants\n  </a>\n  -->\n  <a ng-href=\"#/products/{{$ctrl.productId}}/properties\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'properties\'}\">\n    Properties\n  </a>\n  <a ng-href=\"#/products/{{$ctrl.productId}}/stocks\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'stocks\'}\">\n    Stock\n  </a>\n</div>\n");
$templateCache.put("app/components/promotion-action-calculator.html","<div class=\"promotion-action-calculator-component\">\n\n  <!-- Spree::Calculator::FlatRate -->\n  <div class=\"promotion-action-calculator-flat-rate\" ng-if=\"$ctrl.isFlatRate()\">\n    <div class=\"form-horizontal\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 control-label\">Calculator</label>\n        <div class=\"col-sm-8\">\n          <p class=\"form-control-static\" ng-if=\"$ctrl.calculator.id\" ng-bind=\"$ctrl.name()\"></p>\n          <select class=\"form-control\" ng-model=\"$ctrl.calculator.type\" ng-if=\"!$ctrl.calculator.id\" ng-options=\"c.type as c.name for c in $ctrl.availableCalculatorOptions\" ng-change=\"$ctrl.reset()\"></select>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 control-label\">Amount</label>\n        <div class=\"col-sm-8\">\n          <input type=\"number\" class=\"form-control\" min=\"0\" ng-model=\"$ctrl.calculator.preferred_amount\" string-to-number>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!-- Spree::Calculator::FlatPercentItemTotal -->\n  <div class=\"promotion-action-flat-percent-item-total\" ng-if=\"$ctrl.isFlatPercent()\">\n    <div class=\"form-horizontal\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 control-label\">Calculator</label>\n        <div class=\"col-sm-8\">\n          <p class=\"form-control-static\" ng-if=\"$ctrl.calculator.id\" ng-bind=\"$ctrl.name()\"></p>\n          <select class=\"form-control\" ng-model=\"$ctrl.calculator.type\" ng-if=\"!$ctrl.calculator.id\" ng-options=\"c.type as c.name for c in $ctrl.availableCalculatorOptions\" ng-change=\"$ctrl.reset()\"></select>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 control-label\">Percent</label>\n        <div class=\"col-sm-8\">\n          <input type=\"number\" class=\"form-control\" min=\"0\" ng-model=\"$ctrl.calculator.preferred_flat_percent\" string-to-number>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/components/promotion-action.html","<div class=\"promotion-action-component\">\n  <!-- Spree::Promotion::Actions::CreateAdjustment -->\n  <div class=\"promotion-action-create-adjustment\" ng-if=\"!$ctrl.action._destroy && $ctrl.action.type == \'Spree::Promotion::Actions::CreateAdjustment\'\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        Apply a discount on the order\n\n        <div class=\"pull-right\" ng-click=\"$ctrl.destroy()\">\n          <span class=\"is-pointer glyphicon glyphicon-remove\"></span>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n      <div class=\"panel-body\">\n        <promotion-action-calculator calculator=\"$ctrl.action.calculator\" available-calculators=\"$ctrl.availableCalculators()\">\n        </promotion-action-calculator>\n      </div>\n    </div>\n  </div>\n\n  <!-- Spree::Promotion::Actions::FreeShipping -->\n  <div class=\"promotion-action-free-shipping\" ng-if=\"!$ctrl.action._destroy && $ctrl.action.type == \'Spree::Promotion::Actions::FreeShipping\'\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        Make all shipments for the order free\n\n        <div class=\"pull-right\" ng-click=\"$ctrl.destroy()\">\n          <span class=\"is-pointer glyphicon glyphicon-remove\"></span>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/promotion-editor.html","<div class=\"promotion-editor-component\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <!-- name -->\n      <formly-form model=\"$ctrl.promotion\" fields=\"[$ctrl.fields[0]]\"></formly-form>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <!-- description -->\n      <formly-form model=\"$ctrl.promotion\" fields=\"[$ctrl.fields[1]]\"></formly-form>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-6\">\n      <!-- code -->\n      <formly-form model=\"$ctrl.promotion\" fields=\"[$ctrl.fields[2]]\"></formly-form>\n    </div>\n    <div class=\"col-sm-6\">\n      <!-- usage limit -->\n      <formly-form model=\"$ctrl.promotion\" fields=\"[$ctrl.fields[3]]\"></formly-form>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-6\">\n      <!-- starts at -->\n      <formly-form model=\"$ctrl.promotion\" fields=\"[$ctrl.fields[4]]\"></formly-form>\n    </div>\n    <div class=\"col-sm-6\">\n      <!-- expires at -->\n      <formly-form model=\"$ctrl.promotion\" fields=\"[$ctrl.fields[5]]\"></formly-form>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/components/promotion-rule.html","<div class=\"promotion-rule-component\">\n  <!-- Spree::Promotion::Rules::ItemTotal -->\n  <div class=\"promotion-rule-item-total\" ng-if=\"!$ctrl.rule._destroy && $ctrl.rule.type == \'Spree::Promotion::Rules::ItemTotal\'\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        Item total meets these criteria\n\n        <div class=\"pull-right\" ng-click=\"$ctrl.destroy()\">\n          <span class=\"is-pointer glyphicon glyphicon-remove\"></span>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"form-horizontal\">\n          <div class=\"form-group\">\n            <label class=\"col-sm-4 control-label\" ng-if=\"$ctrl.rule.preferred_operator_min == \'gt\'\">greater than</label>\n            <label class=\"col-sm-4 control-label\" ng-if=\"$ctrl.rule.preferred_operator_min == \'gte\'\">greater than equal to</label>\n            <div class=\"col-sm-8\">\n              <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.rule.preferred_amount_min\" min=\"0\" string-to-number>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"col-sm-4 control-label\" ng-if=\"$ctrl.rule.preferred_operator_max == \'lt\'\">less than</label>\n            <label class=\"col-sm-4 control-label\" ng-if=\"$ctrl.rule.preferred_operator_max == \'lte\'\">less than equal to</label>\n            <div class=\"col-sm-8\">\n              <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.rule.preferred_amount_max\" min=\"0\" string-to-number>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!-- Spree::Promotion::Rules::OneUsePerUser -->\n  <div class=\"promotion-rule-one-use-per-user\" ng-if=\"!$ctrl.rule._destroy && $ctrl.rule.type == \'Spree::Promotion::Rules::OneUsePerUser\'\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        Only one use per user\n\n        <div class=\"pull-right\" ng-click=\"$ctrl.destroy()\">\n          <span class=\"is-pointer glyphicon glyphicon-remove\"></span>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n\n  <!-- Spree::Promotion::Rules::FirstOrder -->\n  <div class=\"promotion-rule-one-use-per-user\" ng-if=\"!$ctrl.rule._destroy && $ctrl.rule.type == \'Spree::Promotion::Rules::FirstOrder\'\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        Must be the customer\'s first order\n\n        <div class=\"pull-right\" ng-click=\"$ctrl.destroy()\">\n          <span class=\"is-pointer glyphicon glyphicon-remove\"></span>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/components/simple-bool-modal.html","<div class=\"modal-header\">\n  <h4 class=\"modal-title\">{{$ctrl.resolve.title || \'\'}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">{{$ctrl.resolve.message}}</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.yes()\">OK</button>\n  <button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.no()\">Cancel</button>\n</div>\n");
$templateCache.put("app/components/upload-picture-progress.html","<div ng-show=\"$ctrl.files.length > 0\">\n  <p>Uploading {{$ctrl.files.length}} items</p>\n  <div class=\"progress\">\n    <div class=\"progress-bar progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"{{$ctrl.uploadedPercentage()}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{$ctrl.uploadedPercentage()}}%\" ng-class=\"{\'progress-bar-success\': $ctrl.isSuccess(), \'progress-bar-striped\': $ctrl.isUploading(), \'progress-bar-danger\': $ctrl.hasError()}\">\n      Uploaded {{$ctrl.readableUploadedSize()}} ({{$ctrl.uploadedPercentage().toFixed(2)}}%)\n    </div>\n  </div>\n\n  <div class=\"alert alert-danger\" ng-show=\"$ctrl.hasError()\">\n    <strong>Oops!</strong> Please try again.\n  </div>\n</div>");
$templateCache.put("app/components/user-detail-menu.html","<div class=\"list-group\">\n  <a ng-href=\"#/orders/{{$ctrl.orderNum}}/account\" class=\"list-group-item\" ng-class=\"{active: $ctrl.active === \'account\'}\">\n    Account\n  </a>\n</div>\n");
$templateCache.put("app/orders/adjustments.html","<div id=\"layout-order-adjustments\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoadingOrder\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoadingOrder\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/cart\" ng-bind=\"vm.orderNum\"></a></li>\n        <li class=\"active\">Adjustments</li>\n      </ol>\n\n      <div class=\"panel panel-default\" ng-if=\"vm.hasEligibleAdjustment()\">\n        <div class=\"panel-heading\">Adjustments</div>\n\n        <table class=\"table\">\n          <tr>\n            <th>Adjustable</th>\n            <th>Description</th>\n            <th>Amount</th>\n          </tr>\n          <tr ng-repeat=\"adjustment in vm.order.all_adjustments\" ng-if=\"adjustment.eligible\">\n            <td>\n              <span ng-if=\"adjustment.adjustable_type == \'Spree::Order\'\">Order</span>\n              <span ng-if=\"adjustment.adjustable_type == \'Spree::Shipment\'\">Shipment</span>\n            </td>\n            <td ng-bind=\"adjustment.label\"></td>\n            <td ng-bind=\"adjustment.display_amount\"></td>\n          </tr>\n        </table>\n      </div>\n\n      <div class=\"alert alert-info\" ng-if=\"!vm.hasEligibleAdjustment()\">\n        No adjustment found.\n      </div>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'adjustments\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/orders/cart.html","<div id=\"layout-cart\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoading\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoading\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/cart\" ng-bind=\"vm.orderNum\"></a></li>\n        <li class=\"active\">Cart</li>\n      </ol>\n\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">Line items</div>\n        <table class=\"table\">\n          <tr>\n            <th></th>\n            <th>Name</th>\n            <th>Price</th>\n            <th>Quantity</th>\n            <th>Total price</th>\n          </tr>\n          <tr ng-repeat=\"lineItem in vm.order.line_items\">\n            <td>\n              <a ng-href=\"#/products/{{lineItem.variant.product_id}}\">\n                <img class=\"img-rounded is-85x85\" ng-src=\"{{lineItem.variant.pictures[0].images[\'150x150\'].url}}\">\n              </a>\n            </td>\n            <td class=\"is-vertical-middle\">\n              {{lineItem.variant.name}}<br>\n              <span class=\"text-muted\">{{lineItem.variant.sku}}</span>\n            </td>\n            <td class=\"is-vertical-middle\" ng-bind=\"lineItem.single_display_amount\"></td>\n            <td class=\"is-vertical-middle\" ng-bind=\"lineItem.quantity\"></td>\n            <td class=\"is-vertical-middle\" ng-bind=\"lineItem.display_amount\"></td>\n          </tr>\n        </table>\n      </div>\n\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">Summary</div>\n        <ul class=\"list-group\">\n          <li class=\"list-group-item\">\n            <strong>Status:</strong> <span ng-bind=\"vm.order.state\"></span>\n          </li>\n          <li class=\"list-group-item\">\n            <strong>Subtotal:</strong> <span ng-bind=\"vm.order.display_item_total\"></span>\n          </li>\n          <li class=\"list-group-item\">\n            <strong>Shipping rate:</strong> <span ng-bind=\"vm.order.display_ship_total\"></span>\n          </li>\n          <li class=\"list-group-item\">\n            <strong>Adjustment:</strong> <span ng-bind=\"vm.order.display_adjustment_total\"></span>\n          </li>\n          <li class=\"list-group-item\">\n            <strong>Total:</strong> <span ng-bind=\"vm.order.display_total\"></span>\n          </li>\n          <li class=\"list-group-item\">\n            <strong>Payment total:</strong> <span ng-bind=\"vm.order.display_payment_total\"></span>\n          </li>\n          <li class=\"list-group-item\">\n            <strong>Shipment:</strong> <span ng-bind=\"vm.order.shipment_state\"></span>\n          </li>\n          <li class=\"list-group-item\">\n            <strong>Payment:</strong> <span ng-bind=\"vm.order.payment_state\"></span>\n          </li>\n          <li class=\"list-group-item\">\n            <strong>Date completed:</strong> {{vm.order.completed_at | localTime}}\n          </li>\n        </ul>\n      </div>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'cart\'\"></order-detail-menu>\n    </div>\n</div></div>");
$templateCache.put("app/orders/create-customer-return.html","<div id=\"layout-create-customer-return\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoading()\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoading()\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/cart\" ng-bind=\"vm.orderNum\"></a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/customer_returns\">Customer returns</a></li>\n        <li class=\"active\">Create</li>\n      </ol>\n\n      <div class=\"alert alert-info\" ng-if=\"vm.returnItems.length == 0\">\n        All items have been returned,\n        <a ng-href=\"#/orders/{{vm.orderNum}}/customer_returns\">Back To Customer Return List.</a>\n      </div>\n\n      <div ng-if=\"vm.returnItems.length > 0\">\n        <div class=\"panel panel-default\" ng-if=\"vm.returnItems.length > 0\">\n          <div class=\"panel-heading\">Items</div>\n\n          <table class=\"table\">\n            <tr>\n              <th></th>\n              <th>Product</th>\n              <th>Refund amount</th>\n              <th>Resellable</th>\n            </tr>\n            <tr ng-repeat=\"ri in vm.returnItems\">\n              <td>\n                <input type=\"checkbox\" ng-model=\"vm.customerReturn.return_items_attributes[$index].returned\">\n              </td>\n              <td>\n                <span ng-bind=\"ri.inventory_unit.variant.name\"></span>\n                <br>\n                <span class=\"text-muted\" ng-bind=\"ri.inventory_unit.variant.sku\"></span>\n              </td>\n              <td ng-bind=\"ri.display_pre_tax_amount\"></td>\n              <td>\n                <input type=\"checkbox\" ng-model=\"vm.customerReturn.return_items_attributes[$index].resellable\">\n              </td>\n            </tr>\n          </table>\n        </div>\n\n        <div>\n          <div class=\"form-group\">\n            <label>Stock Location</label>\n            <select class=\"form-control\" ng-model=\"vm.customerReturn.stock_location_id\" ng-options=\"loc.id as loc.name for loc in vm.stockLocations\">\n            </select>\n          </div>\n        </div>\n\n        <button class=\"btn btn-primary\" ng-disabled=\"!vm.canCreateCustomerReturn() || vm.isCreatingCustomerReturn\" ng-click=\"vm.createCustomerReturn()\">Create</button>\n\n        <alert error=\"vm.createCustomerReturnErrorObj\"></alert>\n      </div>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'customer_returns\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/orders/create-rma.html","<div id=\"layout-create-rma\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoading()\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoading()\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/cart\" ng-bind=\"vm.orderNum\"></a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/rmas\">Return Authorizations</a></li>\n        <li class=\"active\">Create</li>\n      </ol>\n\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">Items</div>\n\n        <table class=\"table\">\n          <tr>\n            <th></th>\n            <th>Product</th>\n            <th>State</th>\n            <th>Charged</th>\n            <th>Reimbursement</th>\n          </tr>\n          <tr ng-repeat=\"ri in vm.returnItems\">\n            <td>\n              <input type=\"checkbox\" ng-disabled=\"!ri.editable\" ng-model=\"vm.rma.return_items_attributes[$index]._destroy\" ng-true-value=\"0\" ng-false-value=\"1\">\n            </td>\n            <td>\n              <span ng-bind=\"ri.inventory_unit.variant.name\"></span>\n              <br>\n              <span class=\"text-muted\" ng-bind=\"ri.inventory_unit.variant.sku\"></span>\n            </td>\n            <td>\n              <span class=\"label label-success\" ng-bind=\"ri.inventory_unit.state\" ng-show=\"ri.inventory_unit.state == \'shipped\'\"></span>\n              <span class=\"label label-warning\" ng-bind=\"ri.inventory_unit.state\" ng-show=\"ri.inventory_unit.state == \'returned\'\"></span>\n            </td>\n            <td ng-bind=\"ri.display_pre_tax_amount\"></td>\n            <td>\n              <div class=\"form-inline\" ng-show=\"ri.editable\">\n                <div class=\"form-group\">\n                  <input type=\"number\" class=\"form-control\" min=\"0\" ng-model=\"vm.rma.return_items_attributes[$index].pre_tax_amount\" ng-minlength=\"0\">\n                </div>\n              </div>\n              <span ng-bind=\"ri.display_pre_tax_amount\" ng-hide=\"ri.editable\"></span>\n            </td>\n          </tr>\n        </table>\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <label>Stock Location</label>\n          <select class=\"form-control\" ng-model=\"vm.rma.stock_location_id\" ng-options=\"loc.id as loc.name for loc in vm.stockLocations\">\n          </select>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Reason</label>\n          <select class=\"form-control\" ng-model=\"vm.rma.return_authorization_reason_id\" ng-options=\"reason.id as reason.name for reason in vm.reasons\">\n          </select>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Memo</label>\n          <textarea class=\"form-control is-vertical-resizable\" rows=\"3\" ng-model=\"vm.rma.memo\"></textarea>\n        </div>\n      </div>\n\n      <button class=\"btn btn-primary\" ng-disabled=\"!vm.canCreateRMA() || vm.isCreatingRMA\" ng-click=\"vm.createRMA()\">Create</button>\n\n      <alert error=\"vm.createRMAErrorObj\"></alert>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'rmas\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/orders/customer-return.html","<div id=\"layout-customer-return\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoading()\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoading()\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/cart\" ng-bind=\"vm.orderNum\"></a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/customer_returns\">Customer Returns</a></li>\n        <li class=\"active\">{{vm.customerReturnId}}</li>\n      </ol>\n\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">Accepted items</div>\n\n        <table class=\"table\">\n          <tr>\n            <th>Product</th>\n            <th>Charged</th>\n            <th>Acceptance errors</th>\n          </tr>\n          <tr ng-repeat=\"ri in vm.returnItems\">\n            <td>\n              <span ng-bind=\"ri.inventory_unit.variant.name\"></span>\n              <br>\n              <span class=\"text-muted\" ng-bind=\"ri.inventory_unit.variant.sku\"></span>\n            </td>\n            <td ng-bind=\"ri.display_pre_tax_amount\"></td>\n            <td>\n              <span ng-show=\"ri.acceptance_status_errors\">\n                {{ri.acceptance_status_errors | json}}\n              </span>\n              <span ng-hide=\"ri.acceptance_status_errors\">N/A</span>\n            </td>\n          </tr>\n        </table>\n      </div>\n\n      <div class=\"panel panel-default\" ng-show=\"vm.reimbursements.length > 0\">\n        <div class=\"panel-heading\">Reimbursements</div>\n\n        <table class=\"table\">\n          <tr>\n            <th>Number</th>\n            <th>Total</th>\n            <th>Status</th>\n            <th>Time</th>\n          </tr>\n          <tr ng-repeat=\"r in vm.reimbursements\">\n            <td>\n              <a ng-show=\"r.reimbursement_status == \'pending\'\" ng-href=\"#/orders/{{vm.orderNum}}/reimbursements/{{r.id}}\">\n                {{r.number}}\n              </a>\n              <span ng-hide=\"r.reimbursement_status == \'pending\'\" ng-bind=\"r.number\"></span>\n            </td>\n            <td ng-bind=\"r.display_total\"></td>\n            <td>\n              <span class=\"label label-warning\" ng-show=\"r.reimbursement_status == \'pending\'\" ng-bind=\"r.reimbursement_status\"></span>\n              <span class=\"label label-danger\" ng-show=\"r.reimbursement_status == \'errored\'\" ng-bind=\"r.reimbursement_status\"></span>\n              <span class=\"label label-success\" ng-show=\"r.reimbursement_status == \'reimbursed\'\" ng-bind=\"r.reimbursement_status\"></span>\n            </td>\n            <td>{{r.updated_at | localTime}}</td>\n          </tr>\n        </table>\n      </div>\n\n      <div ng-hide=\"vm.reimbursements.length > 0\">\n        <a class=\"btn btn-danger pull-right\" ng-click=\"vm.reimburse()\" ng-disabled=\"vm.isReimbursing\">\n           Reimburse\n        </a>\n        <img class=\"pull-right u-width-30\" src=\"/image/loading.gif\" ng-show=\"vm.isReimbursing\">\n        <div class=\"clearfix\"></div>\n      </div>\n\n      <alert error=\"vm.reimbursementErrorObj\"></alert>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'customer_returns\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/orders/customer-returns.html","<div id=\"layout-order-customer-returns\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoadingOrder || vm.isLoadingCustomerReturn\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoadingOrder && !vm.isLoadingCustomerReturn\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.order.number}}/cart\" ng-bind=\"vm.order.number\"></a></li>\n        <li class=\"active\">Customer Returns</li>\n      </ol>\n\n      <div class=\"panel panel-default\" ng-if=\"vm.hasShippedShipment() && vm.hasCustomerReturn()\">\n        <div class=\"panel-heading\">Customer Returns</div>\n        <table class=\"table\">\n          <tr>\n            <th>Return number</th>\n            <th>Refund amount</th>\n            <th>Date</th>\n            <th>Reimbursement status</th>\n          </tr>\n          <tr ng-repeat=\"cr in vm.customerReturns\">\n            <td>\n              <a ng-href=\"#/orders/{{vm.orderNum}}/customer_returns/{{cr.id}}\" ng-bind=\"cr.number\"></a>\n            </td>\n            <td ng-bind=\"cr.display_pre_tax_total\"></td>\n            <td>{{cr.created_at | localTime}}</td>\n            <td>\n              <span class=\"label label-success\" ng-show=\"cr.fully_reimbursed\">Reimbursed</span>\n              <span class=\"label label-warning\" ng-hide=\"cr.fully_reimbursed\">Incomplete</span>\n            </td>\n          </tr>\n        </table>\n      </div>\n\n      <div ng-if=\"vm.hasShippedShipment() && !vm.hasCustomerReturn()\">\n        <div class=\"alert alert-info\" role=\"alert\">\n          No customer returns found.\n        </div>\n      </div>\n\n      <div class=\"alert alert-danger\" role=\"alert\" ng-if=\"!vm.hasShippedShipment()\">\n        Cannot create customer returns as this order has no shipped units.\n      </div>\n\n      <div ng-if=\"vm.hasShippedShipment()\">\n        <div class=\"pull-right\">\n          <a class=\"btn btn-success\" ng-href=\"{{vm.createCustomerReturnUrl()}}\">New Customer Return</a>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n\n      <div ng-if=\"vm.hasCustomerReturn()\">\n        <div class=\"page-header\">\n          <h4>Customer return notification</h4>\n        </div>\n        <p>Send customer return notification email to user</p>\n        <p>\n          <button class=\"btn btn-danger\" ng-click=\"vm.trySendCustomerReturnEmail()\">\n            <span class=\"glyphicon glyphicon-envelope\"></span>\n            Send customer return email\n          </button>\n        </p>\n      </div>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.order.number\" active=\"\'customer_returns\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/orders/customer.html","<div id=\"layout-order-customer\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoading\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoading\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/cart\" ng-bind=\"vm.orderNum\"></a></li>\n        <li class=\"active\">Customer</li>\n      </ol>\n\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">Account</div>\n        <div class=\"panel-body\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">ID</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.user_id || \'N/A\'\"></p>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-repeat=\"billAddressAttr in vm.billAddressAttributes\">\n              <label class=\"col-sm-2 control-label\" ng-bind=\"billAddressAttr.label\"></label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.bill_address[billAddressAttr.key] || \'N/A\'\"></p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">Shipping Address</div>\n        <div class=\"panel-body\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\" ng-repeat=\"shippingAddressAttr in vm.shippingAddressAttributes\">\n              <label class=\"col-sm-2 control-label\" ng-bind=\"shippingAddressAttr.label\"></label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.ship_address[shippingAddressAttr.key] || \'N/A\'\"></p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Address</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\">\n                  {{vm.order.ship_address.zipcode}}\n                  {{vm.order.ship_address.state.name}}{{vm.order.ship_address.address1}}\n                </p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Preferred Time</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.shipping_time_slot.name\"></p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- ecpay invoice -->\n      <div class=\"panel panel-default\" ng-if=\"vm.order.ecpay_invoice\">\n        <div class=\"panel-heading\">Invoice</div>\n        <div class=\"panel-body\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\" ng-repeat=\"invoiceAttr in vm.ecpayInvoiceAttributes\">\n              <label class=\"col-sm-2 control-label\" ng-bind=\"invoiceAttr.label\"></label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.ecpay_invoice[invoiceAttr.key]\"></p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Carrier</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-if=\"vm.order.ecpay_invoice.carrier_type === \'CITIZEN_DIGITAL_CERT\'\">\n                  Citizen digital certificate ({{vm.order.ecpay_invoice.carrier_number}})\n                </p>\n                <p class=\"form-control-static\" ng-if=\"vm.order.ecpay_invoice.carrier_type === \'MOBILE\'\">\n                  Mobile ({{vm.order.ecpay_invoice.carrier_number}})\n                </p>\n                <p class=\"form-control-static\" ng-if=\"vm.order.ecpay_invoice.carrier_type === \'\'\">N/A</p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Donation</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.ecpay_invoice.donation ? \'Yes\' : \'No\'\"></p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Print</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.ecpay_invoice.print ? \'Yes\' : \'No\'\"></p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- paper invoice -->\n      <div class=\"panel panel-default\" ng-if=\"vm.order.invoice && !vm.order.ecpay_invoice\">\n        <div class=\"panel-heading\">Invoice</div>\n        <div class=\"panel-body\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Type</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-show=\"vm.invoiceType()\" ng-bind=\"vm.invoiceType()\"></p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Name</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.invoice.customer_name\"></p>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-show=\"vm.order.invoice.invoice_type != 0\">\n              <label class=\"col-sm-2 control-label\">Address</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\">\n                  {{vm.order.invoice.zipcode}} {{vm.order.invoice.address}}\n                </p>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-show=\"vm.order.invoice.invoice_type != 0\">\n              <label class=\"col-sm-2 control-label\">Phone</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.invoice.phone\"></p>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-show=\"vm.order.invoice.invoice_type == 2\">\n              <label class=\"col-sm-2 control-label\">Company</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.invoice.company\"></p>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-show=\"vm.order.invoice.invoice_type == 2\">\n              <label class=\"col-sm-2 control-label\">Tax ID</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\" ng-bind=\"vm.order.invoice.tax_id\"></p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'customer\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/orders/index.html","<div id=\"layout-orders\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <strong class=\"panel-title\">Orders</strong>\n    </div>\n\n    <div class=\"panel-body\">\n      <form ng-submit=\"vm.fetch(1)\">\n        <div class=\"input-group\" style=\"margin-bottom: 15px\">\n          <span class=\"input-group-btn\">\n            <button class=\"btn btn-default\" type=\"button\" ng-class=\"{dropup: vm.showAdvancedOptions}\" ng-click=\"vm.toggleAdvancedOptions()\">\n              Filter\n              <span class=\"caret\"></span>\n            </button>\n          </span>\n          <input type=\"text\" class=\"form-control\" placeholder=\"Search orders...\" ng-model=\"vm.query[\'q[number_cont]\']\">\n        </div>\n\n        <div class=\"well\" ng-if=\"vm.showAdvancedOptions\">\n          Under construction...\n        </div>\n      </form>\n    </div>\n\n    <table class=\"table\" ng-show=\"!vm.isLoading\">\n      <tr>\n        <th></th>\n        <th>Time</th>\n        <th>Number</th>\n        <th>State</th>\n        <th>Payment</th>\n        <th>Shipment</th>\n        <th>Customer</th>\n        <th>Total</th>\n      </tr>\n      <tr ng-repeat=\"order in vm.orders\">\n        <td>\n          <div class=\"form-inline\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"order.selected\" ng-true-value=\"true\" ng-false-value=\"false\">\n              </label>\n            </div>\n          </div>\n        </td>\n        <td>\n          {{order.completed_at | localTime}}\n        </td>\n        <td>\n          <a ng-href=\"#/orders/{{order.number}}/cart\" ng-bind=\"order.number\"></a>\n        </td>\n        <td>\n          <span class=\"label label-success\" ng-show=\"order.state == \'complete\'\" ng-bind=\"order.state\"></span>\n          <span class=\"label label-warning\" ng-show=\"order.state != \'complete\'\" ng-bind=\"order.state\"></span>\n        </td>\n        <td>\n          <span class=\"label label-success\" ng-show=\"order.payment_state == \'paid\'\" ng-bind=\"order.payment_state\"></span>\n          <span class=\"label label-warning\" ng-show=\"order.payment_state != \'paid\'\" ng-bind=\"order.payment_state\"></span>\n        </td>\n        <td>\n          <span class=\"label label-success\" ng-show=\"order.shipment_state == \'shipped\'\" ng-bind=\"order.shipment_state\"></span>\n          <span class=\"label label-warning\" ng-show=\"order.shipment_state != \'shipped\'\" ng-bind=\"order.shipment_state\"></span>\n        </td>\n        <td>\n          <span ng-show=\"order.user_id\">\n            <a ng-href=\"#/users/{{order.user_id}}\" ng-bind=\"order.user_id\"></a>\n          </span>\n          <span ng-show=\"!order.user_id\">N/A</span>\n        </td>\n        <td ng-bind=\"order.display_total\"></td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"form-inline\" ng-show=\"!vm.isLoading\">\n    <img src=\"image/arrow_ltr.png\" style=\"padding-left: 5px\">\n\n    <div class=\"checkbox\">\n      <label><input type=\"checkbox\" ng-model=\"vm.isAllOrdersSelected\" ng-change=\"vm.onAllOrderSelectedChange()\"> Select all</label>\n    </div>\n\n    <a class=\"btn btn-default btn-sm\" style=\"margin-left: 15px\" target=\"_self\" ng-disabled=\"!vm.anyOrderSelected()\" ng-href=\"{{vm.getDownloadEzcatCsvLink()}}\">\n      <span class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></span> Export ezcat\n    </a>\n  </div>\n\n  <div class=\"text-center\" ng-if=\"vm.isLoading\">\n    <img src=\"image/loading.gif\">\n  </div>\n\n  <div class=\"text-center\" ng-if=\"!vm.isLoading\">\n    <div paging page=\"vm.currPage\" page-size=\"vm.apiPerPage\" total=\"vm.totalOrders\" paging-action=\"vm.changePage(\'\' + page, page)\">\n    </div>\n  </div>\n</div>");
$templateCache.put("app/orders/payments.html","<div id=\"layout-order-payments\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoading()\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoading()\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/cart\" ng-bind=\"vm.orderNum\"></a></li>\n        <li class=\"active\">Payments</li>\n      </ol>\n\n      <div class=\"panel panel-default\" ng-if=\"vm.order.payments.length > 0\">\n        <div class=\"panel-heading\">Payments</div>\n\n        <ul class=\"list-group\">\n          <li class=\"list-group-item\" ng-repeat=\"payment in vm.order.payments | orderBy:\'-\'\">\n            <div class=\"row\">\n              <div class=\"col-sm-3 text-center\">\n                <img class=\"is-85x85\" src=\"image/credit-card.svg\" alt=\"Credit Card\" ng-show=\"payment.source.choose_payment === \'Credit\'\">\n                <img class=\"is-85x85\" src=\"image/atm.svg\" alt=\"ATM\" ng-show=\"payment.source.choose_payment === \'ATM\'\">\n                <img class=\"is-85x85\" src=\"image/711.svg\" alt=\"CVS\" ng-show=\"payment.source.choose_payment === \'CVS\'\">\n\n                <span class=\"label label-success\" ng-show=\"payment.state == \'completed\'\" ng-bind=\"payment.state\"></span>\n                <span class=\"label label-warning\" ng-show=\"!vm.shouldShowCaptureBtn(payment) && payment.state != \'completed\'\" ng-bind=\"payment.state\"></span>\n                <button class=\"btn btn-success\" ng-show=\"vm.shouldShowCaptureBtn(payment)\" ng-click=\"vm.capture(payment)\" ng-disabled=\"vm.isCapturing\">Capture</button>\n              </div>\n\n              <div class=\"col-sm-5\">\n                <p>\n                  <strong class=\"item-name\">Transaction ID:</strong><br>\n                  {{payment.number}}\n                </p>\n                <p>\n                  <strong class=\"item-name\">Ecpay transaction ID: </strong><br>\n                  {{payment.source.trade_no}}\n                </p>\n                <p>\n                  <strong class=\"item-name\">Created at: </strong><br>\n                  {{payment.created_at | localTime}}\n                </p>\n                <p>\n                  <strong class=\"item-name\">Amount: </strong><br>\n                  {{payment.display_amount}}\n                </p>\n              </div>\n\n              <div class=\"col-sm-4\" ng-show=\"payment.source.choose_payment === \'ATM\'\">\n                <p ng-show=\"payment.source.ecpay_payment_info.ExpireDate\">\n                  <strong class=\"item-name\">Expire date:</strong><br>\n                  {{payment.source.ecpay_payment_info.ExpireDate}} 23:59:59\n                </p>\n                <p ng-show=\"payment.source.ecpay_payment_info.BankCode\">\n                  <strong class=\"item-name\">Bank:</strong><br>\n                  {{payment.source.ecpay_payment_info.PaymentType}} ({{payment.source.ecpay_payment_info.BankCode}})\n                </p>\n                <p ng-show=\"payment.source.ecpay_payment_info.vAccount\">\n                  <strong class=\"item-name\">Virtual account:</strong><br>\n                  {{payment.source.ecpay_payment_info.vAccount}}\n                </p>\n              </div>\n\n              <div class=\"col-sm-4\" ng-show=\"payment.source.choose_payment === \'CVS\'\">\n                <p ng-show=\"payment.source.ecpay_payment_info.ExpireDate\">\n                  <strong class=\"item-name\">Expire date:</strong><br>\n                  {{payment.source.ecpay_payment_info.ExpireDate}}\n                </p>\n                <p ng-show=\"payment.source.ecpay_payment_info.PaymentNo\">\n                  <strong class=\"item-name\">Payment No:</strong><br>\n                  {{payment.source.ecpay_payment_info.PaymentNo}}\n                </p>\n              </div>\n            </div>\n          </li>\n        </ul>\n      </div>\n\n      <div class=\"alert alert-info\" ng-if=\"vm.order.payments.length == 0\">\n        No payments found.\n      </div>\n\n      <div class=\"panel panel-default\" ng-if=\"vm.refunds.length > 0\">\n        <div class=\"panel-heading\">Refunds</div>\n        <table class=\"table\">\n          <tr>\n            <th>Transaction ID</th>\n            <th>Ecpay transaction ID</th>\n            <th>Time</th>\n            <th>Amount</th>\n          </tr>\n\n          <tr ng-repeat=\"refund in vm.refunds\">\n            <td ng-bind=\"refund.payment.number\"></td>\n            <td ng-bind=\"refund.transaction_id\"></td>\n            <td>{{refund.updated_at | localTime}}</td>\n            <td ng-bind=\"refund.display_amount\"></td>\n          </tr>\n        </table>\n      </div>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'payments\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/orders/rmas.html","<div id=\"layout-order-rmas\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoadingOrder || vm.isLoadingRMA\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoadingOrder && !vm.isLoadingRMA\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.order.number}}/cart\" ng-bind=\"vm.order.number\"></a></li>\n        <li class=\"active\">Return Authorizations</li>\n      </ol>\n\n      <div class=\"panel panel-default\" ng-if=\"vm.hasShippedShipment() && vm.hasReturnAuthorization()\">\n        <div class=\"panel-heading\">Return authorizations</div>\n        <table class=\"table\">\n          <tr>\n            <th>RMA number</th>\n            <th>Refund amount</th>\n            <th>Date</th>\n            <th></th>\n          </tr>\n          <tr ng-repeat=\"rma in vm.rmas\">\n            <td ng-bind=\"rma.number\"></td>\n            <td ng-bind=\"rma.display_pre_tax_total\"></td>\n            <td>{{rma.created_at | localTime}}</td>\n            <td>\n              <div class=\"btn-group\" role=\"group\">\n                <a class=\"btn btn-primary btn-xs\" ng-href=\"#/orders/{{vm.orderNum}}/rmas/{{rma.id}}\">\n                  <span class=\"glyphicon glyphicon-pencil\"></span>\n                </a>\n                <a class=\"btn btn-danger btn-xs\" ng-if=\"!rma.has_return_item\" ng-click=\"vm.deleteRMA(rma)\">\n                  <span class=\"glyphicon glyphicon-trash\"></span>\n                </a>\n              </div>\n            </td>\n          </tr>\n        </table>\n      </div>\n\n      <div ng-if=\"vm.hasShippedShipment() && !vm.hasReturnAuthorization()\">\n        <div class=\"alert alert-info\" role=\"alert\">\n          No return authorizations found.\n        </div>\n      </div>\n\n      <div class=\"alert alert-danger\" role=\"alert\" ng-if=\"!vm.hasShippedShipment()\">\n        Cannot create returns as this order has no shipped units.\n      </div>\n\n      <div ng-if=\"vm.hasShippedShipment()\">\n        <div class=\"pull-right\">\n          <a class=\"btn btn-success\" ng-href=\"{{vm.createRMAUrl()}}\">New Return Authorization</a>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n\n      <div ng-if=\"vm.hasShippedShipment()\">\n        <div class=\"page-header\">\n          <h4>RMA terms</h4>\n        </div>\n        <p>Send RMA terms email to user</p>\n        <p>\n          <button class=\"btn btn-danger\" ng-click=\"vm.trySendRmaTermsEmail()\">\n            <span class=\"glyphicon glyphicon-envelope\"></span>\n            Send RMA terms email\n          </button>\n        </p>\n      </div>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'rmas\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/orders/shipments.html","<div id=\"layout-order-shipments\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoadingOrder\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoadingOrder\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/cart\" ng-bind=\"vm.orderNum\"></a></li>\n        <li class=\"active\">Shipments</li>\n      </ol>\n\n      <p>\n        <button class=\"btn btn-danger pull-right\" ng-click=\"vm.tryCancelFailedDeliveryOrder()\" ng-if=\"vm.showCancelFailedDeliveryOrder()\">\n          <span class=\"glyphicon glyphicon-trash\"></span>\n          Failed delivery\n        </button>\n        </p><div class=\"clearfix\"></div>\n      <p></p>\n\n      <div class=\"panel panel-default\" ng-repeat=\"shipment in vm.order.shipments\">\n        <div class=\"panel-heading\">\n          {{shipment.number}}\n          <a class=\"panel-heading-btn btn btn-sm btn-success pull-right\" ng-show=\"shipment.state == \'ready\'\" ng-disabled=\"vm.isUpdatingShipment\" ng-click=\"vm.ship(shipment)\">\n            Ship\n          </a>\n          <span class=\"label label-success pull-right\" ng-show=\"shipment.delivered_at\">delivered</span>\n          <div class=\"clearfix\"></div>\n        </div>\n\n        <div class=\"panel-body\">\n          <div class=\"form-group\">\n            <label>Tracking number</label>\n            <div class=\"form-inline\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"shipment.tracking\">\n              <button class=\"btn btn-primary btn-default\" ng-click=\"vm.updateShipment(shipment)\" ng-disabled=\"vm.isUpdatingShipment\">Save</button>\n              <img src=\"image/loading.gif\" class=\"u-width-30\" ng-show=\"vm.isUpdatingShipment\">\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"vm.ezcatTrackingUrl(shipment)\">\n            <label>Ezcat delivery status</label>\n            <p class=\"form-control-static\">\n              <a href=\"{{vm.ezcatTrackingUrl(shipment)}}\" target=\"_blank\" ng-bind=\"vm.ezcatTrackingUrl(shipment)\"></a>\n            </p>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"vm.showFailedDeliveryBtn(shipment)\">\n            <label>Failed delivery</label>\n            <p class=\"form-control-static\">\n              <button class=\"btn btn-danger\" ng-click=\"vm.trySendFailedDeliveryMail()\">\n                <span class=\"glyphicon glyphicon-envelope\"></span>\n                Send failed delivery email\n              </button>\n            </p>\n          </div>\n        </div>\n      </div>\n\n      <alert error=\"vm.updateShipmentErrorObj\"></alert>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'shipments\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/orders/update-rma.html","<div id=\"layout-update-rma\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\" ng-if=\"vm.isLoading()\">\n      <div class=\"text-center\">\n        <img src=\"image/loading.gif\">\n      </div>\n    </div>\n\n    <div class=\"col-sm-8\" ng-if=\"!vm.isLoading()\">\n      <ol class=\"breadcrumb\">\n        <li><a href=\"#/orders\">Orders</a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/cart\" ng-bind=\"vm.orderNum\"></a></li>\n        <li><a ng-href=\"#/orders/{{vm.orderNum}}/rmas\">Return Authorizations</a></li>\n        <li class=\"active\">Update</li>\n      </ol>\n\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">Items</div>\n\n        <table class=\"table\">\n          <tr>\n            <th></th>\n            <th>Product</th>\n            <th>State</th>\n            <th>Charged</th>\n            <th>Reimbursement</th>\n          </tr>\n          <tr ng-repeat=\"ri in vm.returnItems\">\n            <td>\n              <input type=\"checkbox\" ng-disabled=\"!ri.editable\" ng-model=\"vm.rma.return_items_attributes[$index]._destroy\" ng-true-value=\"0\" ng-false-value=\"1\">\n            </td>\n            <td>\n              <span ng-bind=\"ri.inventory_unit.variant.name\"></span>\n              <br>\n              <span class=\"text-muted\" ng-bind=\"ri.inventory_unit.variant.sku\"></span>\n            </td>\n            <td>\n              <span class=\"label label-success\" ng-bind=\"ri.inventory_unit.state\" ng-show=\"ri.inventory_unit.state == \'shipped\'\"></span>\n              <span class=\"label label-warning\" ng-bind=\"ri.inventory_unit.state\" ng-show=\"ri.inventory_unit.state == \'returned\'\"></span>\n            </td>\n            <td ng-bind=\"ri.display_pre_tax_amount\"></td>\n            <td>\n              <div class=\"form-inline\" ng-show=\"ri.editable\">\n                <div class=\"form-group\">\n                  <input type=\"number\" class=\"form-control\" min=\"0\" string-to-number ng-model=\"vm.rma.return_items_attributes[$index].pre_tax_amount\" ng-minlength=\"0\">\n                </div>\n              </div>\n              <span ng-bind=\"ri.display_pre_tax_amount\" ng-show=\"!ri.editable && ri.inventory_unit.state == \'returned\'\"></span>\n            </td>\n          </tr>\n        </table>\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <label>Stock Location</label>\n          <select class=\"form-control\" ng-model=\"vm.rma.stock_location_id\" ng-options=\"loc.id as loc.name for loc in vm.stockLocations\">\n          </select>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Reason</label>\n          <select class=\"form-control\" ng-model=\"vm.rma.return_authorization_reason_id\" ng-options=\"reason.id as reason.name for reason in vm.reasons\">\n          </select>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Memo</label>\n          <textarea class=\"form-control is-vertical-resizable\" rows=\"3\" ng-model=\"vm.rma.memo\"></textarea>\n        </div>\n      </div>\n\n      <button class=\"btn btn-primary\" ng-disabled=\"!vm.canUpdateRMA() || vm.isUpdatingRMA\" ng-click=\"vm.updateRMA()\">Save</button>\n\n      <alert error=\"vm.updateRMAErrorObj\"></alert>\n\n      <div>\n        <div class=\"page-header\">\n          <h4>RMA notification</h4>\n        </div>\n        <p>Send RMA notification email to user</p>\n        <p>\n          <button class=\"btn btn-danger\" ng-click=\"vm.trySendRmaNotificationEmail()\">\n            <span class=\"glyphicon glyphicon-envelope\"></span>\n            Send RMA notification email\n          </button>\n        </p>\n      </div>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <approve-order order-num=\"vm.orderNum\"></approve-order>\n      <order-detail-menu order-num=\"vm.orderNum\" active=\"\'rmas\'\"></order-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/products/create.html","<div id=\"layout-create-product\">\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <form ng-submit=\"vm.onSubmit()\" name=\"vm.form\" novalidate>\n        <div class=\"panel panel-default\" id=\"create-product-panel\">\n          <div class=\"panel-heading\">Create product</div>\n          <div class=\"panel-body\">\n            <formly-form model=\"vm.product\" fields=\"vm.fields\">\n              <div class=\"form-group\" ng-class=\"{\'has-error\': (form.$submitted || form.productAvailableOn.$touched) && form.productAvailableOn.$error.date}\">\n                <label for=\"available-on\">Available on</label>\n                <input type=\"datetime-local\" class=\"form-control\" id=\"available-on\" name=\"productAvailableOn\" placeholder=\"yyyy-MM-ddTHH:mm:ss\" string-to-date ng-model=\"vm.product.available_on\">\n                <span class=\"help-block\">Incorrect date</span>\n              </div>\n            </formly-form>\n\n            <div class=\"alert alert-danger\" ng-show=\"vm.createErrorObj\">\n              <ul>\n                <li ng-repeat=\"(errorKey, errors) in vm.createErrorObj\">\n                  {{errorKey}}\n                  <ul>\n                    <li ng-repeat=\"message in errors\" ng-bind=\"message\"></li>\n                  </ul>\n                </li>\n              </ul>\n            </div>\n          </div>\n          <div class=\"panel-footer\">\n            <button class=\"btn btn-primary\" id=\"save-btn\" type=\"submit\" ng-disabled=\"vm.form.$invalid\">Create</button>\n              <a class=\"btn btn-default\" href=\"#/products\">Cancel</a>\n          </div>\n        </div>\n      </form>\n\n      <div class=\"panel panel-default\" id=\"import-product-panel\">\n        <div class=\"panel-heading\">Import products</div>\n        <div class=\"panel-body\">\n          <div class=\"form-group\">\n            <label>Import from CSV file:</label>\n            <input type=\"file\" ngf-select ngf-accept=\"\'.csv\'\" ng-model=\"vm.csvFile\">\n            <p class=\"help-block\">\n              <a target=\"_self\" ng-href=\"{{vm.templateCsvUrl()}}\">\n                <span class=\"glyphicon glyphicon-list-alt\"></span> CSV template\n              </a>\n            </p>\n          </div>\n\n          <div class=\"alert alert-danger\" role=\"alert\" ng-show=\"vm.badImportResults.length > 0\">\n            <div ng-repeat=\"importResult in vm.badImportResults\">\n              <strong ng-bind=\"importResult.name\"></strong>\n              <span ng-bind=\"importResult.error\"></span>\n            </div>\n          </div>\n\n          <alert error=\"vm.importErrorObj\"></alert>\n        </div>\n        <div class=\"panel-footer\">\n          <button class=\"btn btn-primary\" ng-disabled=\"!vm.csvFile\" ng-click=\"vm.import()\">Upload</button>\n          <img src=\"/image/loading-no-bg.gif\" ng-show=\"vm.isImporting\" class=\"u-width-30\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/products/images.html","<div id=\"layout-product-images\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\">\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n          <strong class=\"panel-title\">Product images</strong>\n          <a class=\"panel-heading-btn btn btn-sm btn-success pull-right\" ng-disabled=\"vm.isUploading\" ng-click=\"vm.openCreateImageModal()\">\n            <span class=\"glyphicon glyphicon-plus\"></span> Create image\n          </a>\n          <div class=\"clearfix\"></div>\n        </div>\n\n        <div class=\"panel-body\" ng-if=\"vm.newPictures.length > 0\">\n          <upload-picture-progress files=\"vm.newPictures\" product-id=\"vm.product.id\" viewable-id=\"vm.product.master.id\" on-create=\"vm.onCreate(resp)\" on-complete=\"vm.onComplete()\">\n          </upload-picture-progress>\n        </div>\n\n        <ul class=\"list-group\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.pictures\">\n          <li class=\"list-group-item is-moveable\" ng-repeat=\"pic in vm.pictures\">\n            <div class=\"media\">\n              <div class=\"media-left\">\n                <img class=\"media-object is-square-85 img-rounded\" ng-src=\"{{pic.thumbnailUrl()}}\">\n              </div>\n\n              <div class=\"media-body\">\n                <div class=\"row\">\n                  <div class=\"col-sm-9 col-md-10\">\n                    <formly-form model=\"pic\" fields=\"vm.picFields\"></formly-form>\n                  </div>\n\n                  <div class=\"col-sm-3 col-md-2\">\n                    <span class=\"pull-right is-relative\" style=\"top: 25px\">\n                      <a class=\"btn btn-danger\" role=\"button\" ng-click=\"vm.delete(pic)\" ng-show=\"!pic.isEditMode\">\n                        <span class=\"glyphicon glyphicon-trash\"></span>\n                      </a>\n                    </span>\n                    <div class=\"clearfix\"></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </li>\n        </ul>\n      </div>\n\n      <alert error=\"vm.errorObj\"></alert>\n\n      <div class=\"pull-right\">\n        <button class=\"btn btn-primary\" ng-click=\"vm.save()\" ng-disabled=\"vm.isSaving\">\n          <span ng-show=\"!vm.isSaving\">Save</span>\n          <span ng-show=\"vm.isSaving\">Saving...</span>\n        </button>\n        <a ng-href=\"{{vm.product.editPath(\'#\')}}\" class=\"btn btn-default\">Cancel</a>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <product-detail-menu product-id=\"vm.product.id\" active=\"\'images\'\"></product-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/products/index.html","<div id=\"layout-products\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <strong class=\"panel-title\">Products</strong>\n      <a class=\"panel-heading-btn btn btn-sm btn-success pull-right\" ng-href=\"#/products/create\">\n        <span class=\"glyphicon glyphicon-plus\"></span> Create product\n      </a>\n      <div class=\"clearfix\"></div>\n    </div>\n    <div class=\"panel-body\">\n      <div class=\"text-center\" ng-if=\"vm.isLoading\">\n        <img src=\"image/loading.gif\">\n      </div>\n\n      <div class=\"form-inline\" ng-if=\"!vm.isLoading\">\n        <fieldset>\n          <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Search product...\" disabled=\"disabled\">\n            <span class=\"input-group-btn\">\n              <button class=\"btn btn-success\" type=\"button\" disabled=\"disabled\">Go!</button>\n            </span>\n          </div>\n\n          <select class=\"form-control\" ng-model=\"vm.apiPerPage\" ng-options=\"\'\' + val + \' items per page\' for val in vm.apiPerPageOptions\" ng-change=\"vm.fetch(1)\"></select>\n\n          <div class=\"checkbox\">\n            <label>\n              <input type=\"checkbox\" ng-model=\"vm.showDeleted\" ng-change=\"vm.fetch(1)\"> Show deleted\n            </label>\n          </div>\n\n          <div class=\"checkbox\">\n            <label>\n              <input type=\"checkbox\" ng-model=\"vm.showDiscontinued\" ng-change=\"vm.fetch(1)\"> Show discontinued\n            </label>\n          </div>\n        </fieldset>\n      </div>\n    </div>\n\n    <table class=\"table\" ng-show=\"!vm.isLoading\">\n      <tr ng-repeat=\"product in vm.products\">\n        <td>\n          <div class=\"row\">\n            <div class=\"col-xs-10 col-sm-11\">\n              <div class=\"media\">\n                <div class=\"media-left\">\n                  <a ng-href=\"{{product.editPath(\'#\')}}\">\n                    <img class=\"img-rounded is-square-80\" ng-src=\"{{product.master.pictures[0].images[\'150x150\'].url}}\">\n                  </a>\n                </div>\n\n                <div class=\"media-body\">\n                  <a class=\"media-heading product-name\" ng-href=\"{{product.editPath(\'#\')}}\">\n                    <span ng-bind=\"product.name\"></span>\n                  </a>\n                  <p ng-bind=\"product.master.sku\"></p>\n                  <p>\n                    <span class=\"item-attr text-muted\">\n                      <i class=\"fa fa-calendar\"></i>\n                      <product-availability product=\"product\"></product-availability>\n                    </span>\n                    <span class=\"item-attr text-muted\">\n                      <i class=\"fa fa-credit-card\"></i>\n                      <span ng-bind=\"product.display_price\"></span>\n                    </span>\n                  </p>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"col-xs-2 col-sm-1\">\n              <button class=\"btn btn-danger pull-right\" disabled=\"disabled\">\n                <span class=\"glyphicon glyphicon-trash\"></span>\n              </button>\n            </div>\n          </div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"text-center\" ng-if=\"!vm.isLoading\">\n    <div paging page=\"vm.currPage\" page-size=\"vm.apiPerPage\" total=\"vm.totalProducts\" paging-action=\"vm.changePage(\'\' + page, page)\">\n    </div>\n  </div>\n</div>");
$templateCache.put("app/products/properties.html","<div id=\"layout-product-properties\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\">\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n          <strong class=\"panel-title\">Properties</strong>\n        </div>\n\n        <ul class=\"list-group\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.properties\">\n          <li class=\"list-group-item\" ng-repeat=\"pp in vm.properties\" ng-if=\"pp.shouldDisplay()\">\n            <div class=\"row is-moveable\" ng-if=\"pp.shouldDisplay()\">\n              <div class=\"col-sm-4\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"property\" ng-model=\"pp.property_name\" ng-change=\"pp.dirty()\">\n              </div>\n\n              <div class=\"col-sm-7\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"value\" ng-model=\"pp.value\" ng-change=\"pp.dirty()\">\n              </div>\n\n              <div class=\"col-sm-1\">\n                <span class=\"pull-right\">\n                  <button class=\"btn btn-danger\" ng-click=\"pp.delete()\">\n                    <span class=\"glyphicon glyphicon-trash\"></span>\n                  </button>\n                </span>\n                <div class=\"clearfix\"></div>\n              </div>\n            </div>\n          </li>\n        </ul>\n      </div>\n\n      <div class=\"text-right\">\n        <button class=\"btn btn-success\" ng-click=\"vm.addProperty()\">Add property</button>\n        <button class=\"btn btn-primary\" ng-click=\"vm.save()\">Save</button>\n        <a class=\"btn btn-default\" ng-href=\"{{vm.product.editPath(\'#\')}}\">Cancel</a>\n      </div>\n\n      <alert error=\"vm.errorObj\"></alert>\n    </div>\n\n    <div class=\"col-sm-4\">\n      <product-detail-menu product-id=\"vm.product.id\" active=\"\'properties\'\"></product-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/products/stocks.html","<div id=\"layout-product-stocks\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\">\n      <div class=\"panel panel-default\">\n        <p class=\"text-center\" style=\"font-size: 64px\" ng-bind=\"vm.countOnHand\"></p>\n        <p class=\"text-center text-muted\">count on hand</p>\n      </div>\n\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n          <strong class=\"panel-title\">Add stock</strong>\n        </div>\n        <div class=\"panel-body\">\n          <form novalidate ng-submit=\"vm.addStock()\" name=\"vm.addStockForm\">\n            <formly-form model=\"vm.stockChange\" fields=\"vm.stockFields\"></formly-form>\n\n            <alert error=\"vm.addStockErrorObj\"></alert>\n\n            <button class=\"btn btn-primary\" ng-disabled=\"vm.addStockForm.$invalid || vm.isAddingStock\">\n              <span ng-if=\"!vm.isAddingStock\">Add stock</span>\n              <span ng-if=\"vm.isAddingStock\">Adding...</span>\n            </button>\n          </form>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-sm-4\">\n      <product-detail-menu product-id=\"vm.product.id\" active=\"\'stocks\'\"></product-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/products/update.html","<div id=\"layout-update-product\">\n  <div class=\"row\">\n    <div class=\"col-sm-8\">\n      <form name=\"form\" name=\"vm.form\" novalidate>\n        <div class=\"panel panel-default\">\n          <div class=\"panel-heading\">Basic</div>\n          <div class=\"panel-body\">\n            <formly-form model=\"vm.product\" fields=\"vm.basicFields\"></formly-form>\n          </div>\n        </div>\n\n        <div class=\"panel panel-default\">\n          <div class=\"panel-heading\">Availability date</div>\n          <div class=\"panel-body\">\n            <formly-form model=\"vm.product\" fields=\"vm.dateFields\"></formly-form>\n          </div>\n        </div>\n\n        <div class=\"panel panel-default\" ng-if=\"!vm.product.has_variants\">\n          <div class=\"panel-heading\">Inventory data</div>\n          <div class=\"panel-body\">\n            <formly-form model=\"vm.product.master\" fields=\"vm.skuField\">\n\n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <formly-form model=\"vm.product.master\" fields=\"[vm.volumeFields[0]]\">\n              </formly-form></div>\n              <div class=\"col-sm-6\">\n                <formly-form model=\"vm.product.master\" fields=\"[vm.volumeFields[1]]\">\n              </formly-form></div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <formly-form model=\"vm.product.master\" fields=\"[vm.volumeFields[2]]\">\n              </formly-form></div>\n              <div class=\"col-sm-6\">\n                <formly-form model=\"vm.product.master\" fields=\"[vm.volumeFields[3]]\">\n              </formly-form></div>\n            </div>\n          </formly-form></div>\n        </div>\n\n        <div class=\"panel panel-default\" ng-if=\"vm.product.has_variants\">\n          <div class=\"panel-heading\">SKUs</div>\n          <div class=\"panel-body\">\n            <ul>\n              <li ng-repeat=\"variant in vm.product.variants\">\n                <a ng-href=\"{{variant.editPath(\'#\')}}\" ng-bind=\"variant.sku\"></a>\n              </li>\n            </ul>\n          </div>\n        </div>\n\n        <div class=\"panel panel-default\">\n          <div class=\"panel-heading\">Selling points</div>\n          <div class=\"panel-body\">\n            <div class=\"form-group\" ng-repeat=\"sp in vm.product.selling_points\">\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"sp.text\">\n                <span class=\"input-group-btn\">\n                  <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.product.selling_points.splice($index, 1)\">\n                    <span class=\"glyphicon glyphicon-trash\"></span>\n                  </button>\n                </span>\n              </div>\n            </div>\n            <button class=\"btn btn-default\" ng-click=\"vm.addSellingPoint()\">Add another selling point</button>\n          </div>\n        </div>\n\n        <div class=\"panel panel-default\">\n          <div class=\"panel-heading\">Attentions</div>\n          <div class=\"panel-body\">\n            <div class=\"form-group\" ng-repeat=\"a in vm.product.attentions\">\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"a.text\">\n                <span class=\"input-group-btn\">\n                  <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.product.attentions.splice($index, 1)\">\n                    <span class=\"glyphicon glyphicon-trash\"></span>\n                  </button>\n                </span>\n              </div>\n            </div>\n            <button class=\"btn btn-default\" ng-click=\"vm.addAttention()\">Add another attention</button>\n          </div>\n        </div>\n\n        <div class=\"panel panel-default\">\n          <div class=\"panel-heading\">Media</div>\n          <div class=\"panel-body\">\n            <div class=\"row\">\n              <div class=\"col-sm-4\">\n                <div class=\"thumbnail\">\n                  <img ng-src=\"{{vm.product.media[0].image}}\" ng-if=\"vm.product.media[0].image\">\n                  <img holder=\"{{vm.defaultMediaImage}}\" ng-if=\"!vm.product.media[0].image\">\n                </div>\n              </div>\n              <div class=\"col-sm-8\">\n                <formly-form model=\"vm.product.media[0]\" fields=\"vm.mediaFields\"></formly-form>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"panel panel-default\">\n          <div class=\"panel-heading\">Description</div>\n          <div class=\"panel-body\">\n            <formly-form model=\"vm.product\" fields=\"vm.descriptionFields\"></formly-form>\n            <formly-form model=\"vm.product.further_readings[0]\" fields=\"vm.furtherReadingFields\"></formly-form>\n          </div>\n        </div>\n\n        <div class=\"panel panel-default\">\n          <div class=\"panel-heading\">SEO</div>\n          <div class=\"panel-body\">\n            <formly-form model=\"vm.product\" fields=\"vm.seoFields\"></formly-form>\n          </div>\n        </div>\n      </form>\n\n      <button class=\"btn btn-primary\" ng-click=\"vm.save()\" ng-disabled=\"vm.isSaving\">Save</button>\n      <a class=\"btn btn-default\" href=\"#/products\">Cancel</a>\n    </div>\n    <div class=\"col-sm-4\">\n      <product-detail-menu product-id=\"vm.product.id\" active=\"\'detail\'\"></product-detail-menu>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/promotions/create.html","<div id=\"layout-create-promotion\">\n  <ol class=\"breadcrumb\">\n    <li><a href=\"#/promotions\">Promotions</a></li>\n    <li class=\"active\">Create</li>\n  </ol>\n\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <strong class=\"panel-title\">Create promotion</strong>\n    </div>\n\n    <div class=\"panel-body\">\n      <promotion-editor promotion=\"vm.promotion\"></promotion-editor>\n      <alert error=\"vm.createErrorObj\"></alert>\n    </div>\n\n    <div class=\"panel-footer\">\n      <button class=\"btn btn-primary\" ng-disabled=\"vm.isCreating\" ng-click=\"vm.create()\">Create</button>\n      <img src=\"/image/loading-no-bg.gif\" class=\"u-width-30\" ng-show=\"vm.isCreating\">\n    </div>\n  </div>\n</div>");
$templateCache.put("app/promotions/index.html","<div id=\"layout-promotions\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <strong class=\"panel-title\">Promotions</strong>\n      <a class=\"panel-heading-btn btn btn-sm btn-success pull-right\" ng-href=\"#/promotions/create\">\n        <span class=\"glyphicon glyphicon-plus\"></span> Create promotion\n      </a>\n      <div class=\"clearfix\"></div>\n    </div>\n\n    <!--\n    <div class=\"panel-body\">\n      <form ng-submit=\"vm.fetch(1)\">\n        <div class=\"input-group\" style=\"margin-bottom: 15px\">\n          <span class=\"input-group-btn\">\n            <button class=\"btn btn-default\" type=\"button\"\n                    ng-class=\"{dropup: vm.showAdvancedOptions}\"\n                    ng-click=\"vm.toggleAdvancedOptions()\">\n              Filter\n              <span class=\"caret\"></span>\n            </button>\n          </span>\n          <input type=\"text\" class=\"form-control\" placeholder=\"Search promotions...\"\n                 ng-model=\"vm.query[\'q[code_cont]\']\">\n        </div>\n\n        <div class=\"well\" ng-if=\"vm.showAdvancedOptions\">\n          Under construction...\n        </div>\n      </form>\n    </div>\n    -->\n\n    <table class=\"table\" ng-show=\"!vm.isLoading && vm.promotions.length > 0\">\n      <tr>\n        <th>Name</th>\n        <th>Code</th>\n        <th>Description</th>\n        <th>Usage</th>\n        <th>Start at</th>\n        <th>Expire at</th>\n        <!--<th></th>-->\n      </tr>\n      <tr ng-repeat=\"promotion in vm.promotions\">\n        <td>\n          <a ng-href=\"#/promotions/{{promotion.id}}\" ng-bind=\"promotion.name\"></a>\n        </td>\n        <td>\n          <span class=\"label label-info\" ng-if=\"promotion.code\" ng-bind=\"promotion.code\"></span>\n          <span ng-if=\"!promotion.code\">N/A</span>\n        </td>\n        <td ng-bind=\"promotion.description || \'N/A\'\"></td>\n        <td>\n          {{promotion.credits_count}} /\n          <span ng-if=\"promotion.usage_limit\" ng-bind=\"promotion.usage_limit\"></span>\n          <span ng-if=\"!promotion.usage_limit\">Unlimited</span>\n        </td>\n        <td>\n          <span ng-if=\"promotion.starts_at\">{{promotion.starts_at | localTime}}</span>\n          <span ng-if=\"!promotion.starts_at\">N/A</span>\n        </td>\n        <td>\n          <span ng-if=\"promotion.expires_at\">{{promotion.expires_at | localTime}}</span>\n          <span ng-if=\"!promotion.expires_at\">N/A</span>\n        </td>\n        <!--\n        <td>\n          <button class=\"btn btn-danger btn-xs\" type=\"button\">\n            <span class=\"glyphicon glyphicon-trash\"></span>\n          </button>\n        </td>\n        -->\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"alert alert-info\" ng-show=\"!vm.isLoading && vm.promotions.length == 0\">\n    No promotion found.\n  </div>\n\n  <div class=\"text-center\" ng-if=\"vm.isLoading\">\n    <img src=\"image/loading.gif\">\n  </div>\n\n  <div class=\"text-center\" ng-if=\"!vm.isLoading\">\n    <div paging page=\"vm.currPage\" page-size=\"vm.apiPerPage\" total=\"vm.totalOrders\" paging-action=\"vm.changePage(\'\' + page, page)\">\n    </div>\n  </div>\n</div>");
$templateCache.put("app/promotions/update.html","<div id=\"layout-update-promotion\">\n  <ol class=\"breadcrumb\">\n    <li><a href=\"#/promotions\">Promotions</a></li>\n    <li class=\"active\" ng-bind=\"vm.promotion.name || vm.promotionId\"></li>\n  </ol>\n\n  <div class=\"text-center\">\n    <img src=\"/image/loading.gif\" ng-if=\"!vm.promotion\">\n  </div>\n\n  <div class=\"panel panel-default\" ng-if=\"vm.promotion\">\n    <div class=\"panel-heading\">\n      <strong class=\"panel-title\">Promotion</strong>\n    </div>\n\n    <div class=\"panel-body\">\n      <promotion-editor promotion=\"vm.promotion\"></promotion-editor>\n      <alert error=\"vm.updateErrorObj\"></alert>\n    </div>\n  </div>\n\n  <div class=\"row\" ng-if=\"vm.promotion\">\n    <div class=\"col-md-6\">\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n          <strong class=\"panel-title\">Rules</strong>\n        </div>\n\n        <div class=\"panel-body\">\n          <div class=\"form-group\">\n            <div class=\"radio\" ng-repeat=\"value in [\'all\', \'any\']\">\n              <label>\n                <input type=\"radio\" ng-model=\"vm.promotion.match_policy\" value=\"{{value}}\">\n                Match <strong ng-bind=\"value\"></strong> of theses rules\n              </label>\n            </div>\n          </div>\n\n          <promotion-rule rule=\"rule\" ng-repeat=\"rule in vm.promotion.promotion_rules\"></promotion-rule>\n        </div>\n\n        <div class=\"panel-footer\">\n          <div class=\"row\">\n            <div class=\"col-md-8\">\n                <select class=\"form-control\" ng-model=\"vm.newRuleType\" ng-options=\"rt.type as rt.name for rt in vm.availableRuleTypes()\" ng-disabled=\"vm.availableRuleTypes().length == 0\"></select>\n            </div>\n            <div class=\"col-md-4\">\n              <button class=\"btn btn-block btn-primary\" ng-disabled=\"vm.availableRuleTypes().length == 0\" ng-click=\"vm.addRule(vm.newRuleType)\">Add a rule</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-md-6\">\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n          <strong class=\"panel-title\">Actions</strong>\n        </div>\n\n        <div class=\"panel-body\">\n          <promotion-action action=\"action\" ng-repeat=\"action in vm.promotion.promotion_actions\"></promotion-action>\n        </div>\n\n        <div class=\"panel-footer\">\n          <div class=\"row\">\n            <div class=\"col-md-8\">\n                <select class=\"form-control\" ng-model=\"vm.newActionType\" ng-options=\"rt.type as rt.name for rt in vm.availableActionTypes()\" ng-disabled=\"vm.availableActionTypes().length == 0\"></select>\n            </div>\n            <div class=\"col-md-4\">\n              <button class=\"btn btn-block btn-primary\" ng-disabled=\"vm.availableActionTypes().length == 0\" ng-click=\"vm.addAction(vm.newActionType)\">Add a action</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <alert error=\"vm.updateErrorObj\"></alert>\n\n  <div ng-show=\"vm.promotion\">\n    <button class=\"btn btn-primary\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.save()\">Save promotion and its rules, actions</button>\n    <img src=\"/image/loading-no-bg.gif\" class=\"u-width-30\" ng-show=\"vm.isSaving\">\n  </div>\n</div>");
$templateCache.put("app/users/index.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <strong class=\"panel-title\">Users</strong>\n  </div>\n\n  <div class=\"panel-body\">\n    <form ng-submit=\"vm.fetch(1)\">\n      <div class=\"input-group\" style=\"margin-bottom: 15px\">\n        <span class=\"input-group-btn\">\n          <button class=\"btn btn-default\" type=\"button\" ng-class=\"{dropup: vm.showAdvancedOptions}\" ng-click=\"vm.toggleAdvancedOptions()\">\n            Filter\n            <span class=\"caret\"></span>\n          </button>\n        </span>\n        <input type=\"text\" class=\"form-control\" placeholder=\"Search users...\" ng-model=\"vm.query[\'q[number_cont]\']\">\n      </div>\n\n      <div class=\"well\" ng-if=\"vm.showAdvancedOptions\">\n        Under construction...\n      </div>\n    </form>\n  </div>\n\n  <table class=\"table\" ng-show=\"!vm.isLoading\">\n    <tr>\n      <th>id</th>\n      <th>email</th>\n      <th>created at</th>\n      <th></th>\n    </tr>\n    <tr ng-repeat=\"user in vm.users\">\n      <td>\n        <span class=\"text-muted\">{{user.id}}</span>\n      </td>\n      <td>\n        <a href=\"#/users/{{user.id}}\">{{user.email || \'N/A\'}}</a>\n      </td>\n      <td>{{user.created_at | localTime}}</td>\n      <td>\n        <a class=\"btn btn-primary btn-xs\" href=\"#/users/{{user.id}}\">\n          <span class=\"glyphicon glyphicon-pencil\"></span>\n        </a>\n      </td>\n    </tr>\n  </table>\n</div>\n\n<div class=\"text-center\" ng-if=\"vm.isLoading\">\n  <img src=\"image/loading.gif\">\n</div>\n\n<div class=\"text-center\" ng-if=\"!vm.isLoading\">\n  <div paging page=\"vm.currPage\" page-size=\"vm.apiPerPage\" total=\"vm.totalUsers\" paging-action=\"vm.changePage(\'\' + page, page)\">\n  </div>\n</div>");
$templateCache.put("app/users/update.html","<div class=\"row\">\n  <div class=\"col-sm-8\" ng-if=\"vm.isLoading\">\n    <div class=\"text-center\">\n      <img src=\"image/loading.gif\">\n    </div>\n  </div>\n\n  <div class=\"col-sm-8\" ng-if=\"!vm.isLoading\">\n    <ol class=\"breadcrumb\">\n      <li><a href=\"#/users\">Users</a></li>\n      <li><a ng-href=\"#/users/{{vm.user.id}}/cart\" ng-bind=\"vm.user.id\"></a></li>\n      <li class=\"active\">Account</li>\n    </ol>\n\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">General</div>\n      <div class=\"panel-body\">\n        <form class=\"form-horizontal\">\n          <div class=\"form-group\">\n            <label class=\"col-sm-3 control-label\">ID</label>\n            <div class=\"col-sm-9\">\n              <p class=\"form-control-static\" ng-bind=\"vm.user.id\"></p>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"col-sm-3 control-label\">Email</label>\n            <div class=\"col-sm-9\">\n              <p class=\"form-control-static\" ng-bind=\"vm.user.email || \'N/A\'\"></p>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"col-sm-3 control-label\">Created at</label>\n            <div class=\"col-sm-9\">\n              <p class=\"form-control-static\">{{vm.user.created_at | localTime}}</p>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-sm-4\">\n    <user-detail-menu user-id=\"vm.user.id\" active=\"\'account\'\"></user-detail-menu>\n  </div>\n</div>");}]);
/// <reference path="../../typings/index.d.ts" />
function MainCtrl(AuthService) {
    var vm = this;
    var user = null;
    this.isAuthenticated = function () {
        return AuthService.isAuthenticated();
    };
}
angular
    .module('app')
    .controller('Main', MainCtrl);

/// <reference path="../../../typings/index.d.ts" />
function stringToDate() {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (value) {
                if (!value) {
                    return null;
                }
                return value.toISOString();
            });
            ngModel.$formatters.push(function (value) {
                var d = new Date(value);
                return d.getTime() ? d : null;
            });
        }
    };
}
angular
    .module('app')
    .directive('stringToDate', stringToDate);

/// <reference path="../../../typings/index.d.ts" />
function stringToNumber() {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (value) {
                if (value === 0) {
                    return '0';
                }
                else if (!value) {
                    return null;
                }
                else {
                    return '' + value;
                }
            });
            ngModel.$formatters.push(function (value) {
                return !value ? null : parseFloat(value);
            });
        }
    };
}
angular
    .module('app')
    .directive('stringToNumber', stringToNumber);

/// <reference path="../../../typings/index.d.ts" />
function LocalTimeFilter() {
    return function (input) {
        var milliSec = Date.parse(input || '');
        if (milliSec) {
            return moment(milliSec.toString(), 'x').format('YYYY-MM-DD HH:mm:ss');
        }
        else {
            return '';
        }
    };
}
angular
    .module('app')
    .filter('localTime', LocalTimeFilter);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function CartCtrl(API_BASE, OrderResource, $routeParams) {
    var vm = this;
    this.isLoading = true;
    this.orderNum = $routeParams.orderNum;
    this.order = OrderResource.get({ number: this.orderNum }, onFetchOrder);
    function onFetchOrder() {
        vm.isLoading = false;
    }
}
angular
    .module('app')
    .controller('Cart', CartCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function CreateCustomerReturnCtrl(API_BASE, OrderResource, $http, $location, $routeParams) {
    var vm = this;
    this.orderNum = $routeParams.orderNum;
    this.isLoadingReturnItems = true;
    this.returnItems = [];
    this.isLoadingStockLocations = true;
    this.stockLocations = [];
    this.customerReturn = {
        return_items_attributes: [],
        stock_location_id: null
    };
    this.isCreatingCustomerReturn = false;
    this.createCustomerReturnErrorObj = null;
    this.isLoading = function () {
        return this.isLoadingReturnItems || this.isLoadingStockLocations;
    };
    this.canCreateCustomerReturn = function () {
        return _.some(this.customerReturn.return_items_attributes, function (ri) { return ri.returned; });
    };
    this.createCustomerReturn = function () {
        var data = { customer_return: angular.copy(this.customerReturn) };
        data.customer_return.return_items_attributes = _.map(_.filter(data.customer_return.return_items_attributes, function (ri) { return ri.returned; }), function (ri) { return _.omit(ri, 'returned'); });
        this.isCreatingCustomerReturn = true;
        $http
            .post(API_BASE + "/orders/" + this.orderNum + "/customer_returns", data)
            .then(onCreateCustomerReturnSuccess, onCreateCustomerReturnError);
    };
    $http
        .get(API_BASE + "/orders/" + this.orderNum + "/customer_returns/return_items")
        .then(onLoadReturnItemSuccess, onLoadReturnItemError);
    $http
        .get(API_BASE + "/stock_locations", { params: { per_page: 100 } })
        .then(onLoadStockLocationSuccess, onLoadStockLocationError);
    function onLoadStockLocationSuccess(resp) {
        vm.isLoadingStockLocations = false;
        vm.stockLocations = resp.data.stock_locations;
        vm.customerReturn.stock_location_id = vm.stockLocations[0].id;
    }
    function onLoadStockLocationError(resp) {
        this.isLoadingStockLocations = false;
        console.error(resp);
    }
    function onLoadReturnItemSuccess(resp) {
        vm.isLoadingReturnItems = false;
        vm.returnItems = resp.data;
        if (resp.data.length === 0) {
            return;
        }
        angular.forEach(resp.data, function (ri) {
            vm.customerReturn.return_items_attributes.push({ id: ri.id, returned: false, resellable: true });
        });
    }
    function onLoadReturnItemError(resp) {
        vm.isLoadingReturnItems = false;
        console.error(resp);
    }
    function onCreateCustomerReturnSuccess(resp) {
        $location.path("/orders/" + vm.orderNum + "/customer_returns");
    }
    function onCreateCustomerReturnError(resp) {
        vm.isCreatingCustomerReturn = false;
        vm.createCustomerReturnErrorObj = resp.data;
        console.error(resp);
    }
}
angular
    .module('app')
    .controller('CreateCustomerReturn', CreateCustomerReturnCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function CreateRMACtrl(API_BASE, OrderResource, $http, $location, $routeParams) {
    var vm = this;
    this.orderNum = $routeParams.orderNum;
    this.isLoadingReturnItems = true;
    this.returnItems = [];
    this.isLoadingStockLocations = true;
    this.stockLocations = [];
    this.isLoadingReasons = true;
    this.reasons = [];
    this.isCreatingRMA = false;
    this.rma = {
        return_items_attributes: [],
        stock_location_id: null,
        return_authorization_reason_id: null,
        memo: ''
    };
    this.createRMAErrorObj = null;
    this.isLoading = function () {
        return this.isLoadingReturnItems ||
            this.isLoadingStockLocations ||
            this.isLoadingReasons;
    };
    this.createRMA = function () {
        this.rma.memo = this.rma.memo.trim();
        this.isCreatingRMA = true;
        var url = API_BASE + "/orders/" + this.orderNum + "/return_authorizations";
        $http
            .post(url, { return_authorization: this.rma })
            .then(onCreateRMASuccess, onCreateRMAError);
    };
    this.canCreateRMA = function () {
        var returnItems = this.rma.return_items_attributes;
        if (this.rma.stock_location_id == null) {
            return false;
        }
        if (this.rma.return_authorization_reason_id == null) {
            return false;
        }
        if (_.every(returnItems, function (ri) { return ri._destroy; })) {
            return false;
        }
        return _.every(returnItems, function (ri) {
            return (ri._destroy ||
                (ri.pre_tax_amount != null && ri.pre_tax_amount >= 0));
        });
    };
    $http
        .get(API_BASE + "/orders/" + this.orderNum + "/return_authorizations/return_items")
        .then(onLoadReturnItemSuccess, onLoadReturnItemError);
    $http
        .get(API_BASE + "/stock_locations", { params: { per_page: 100 } })
        .then(onLoadStockLocationSuccess, onLoadStockLocationError);
    $http
        .get(API_BASE + "/return_authorization_reasons")
        .then(onLoadReasonSuccess, onLoadReasonError);
    function onLoadStockLocationSuccess(resp) {
        vm.isLoadingStockLocations = false;
        vm.stockLocations = resp.data.stock_locations;
        vm.rma.stock_location_id = vm.stockLocations[0].id;
    }
    function onLoadStockLocationError(resp) {
        this.isLoadingStockLocations = false;
        console.error(resp);
    }
    function onLoadReturnItemSuccess(resp) {
        vm.isLoadingReturnItems = false;
        vm.returnItems = resp.data;
        vm.rma.return_items_attributes = _.map(resp.data, function (ri) {
            return {
                inventory_unit_id: ri.inventory_unit.id,
                _destroy: 1,
                pre_tax_amount: null
            };
        });
    }
    function onLoadReturnItemError(resp) {
        vm.isLoadingReturnItems = false;
        console.error(resp);
    }
    function onLoadReasonSuccess(resp) {
        vm.isLoadingReasons = false;
        vm.reasons = resp.data;
        vm.rma.return_authorization_reason_id = vm.reasons[0].id;
    }
    function onLoadReasonError(resp) {
        vm.isLoadingReasons = false;
        console.error(resp);
    }
    function onCreateRMASuccess(resp) {
        $location.path("/orders/" + vm.orderNum + "/rmas");
    }
    function onCreateRMAError(resp) {
        vm.isCreatingRMA = false;
        vm.createRMAErrorObj = resp.data;
        console.error(resp);
    }
}
angular
    .module('app')
    .controller('CreateRMA', CreateRMACtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function OrderAdjustmentsCtrl(API_BASE, OrderResource, $http, $routeParams) {
    var vm = this;
    this.isLoadingOrder = true;
    this.orderNum = $routeParams.orderNum;
    this.order = OrderResource.get({ number: this.orderNum }, function () { vm.isLoadingOrder = false; });
    this.hasEligibleAdjustment = function () {
        return _.some(this.order.all_adjustments, function (a) { return a.eligible; });
    };
}
angular
    .module('app')
    .controller('OrderAdjustments', OrderAdjustmentsCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function CustomerReturnCtrl(API_BASE, OrderResource, $http, $routeParams, $uibModal) {
    var vm = this;
    this.orderNum = $routeParams.orderNum;
    this.customerReturnId = $routeParams.id;
    this.isLoadingReturnItems = true;
    this.returnItems = [];
    this.isLoadingReimbursements = true;
    this.reimbursements = [];
    this.isReimbursing = false;
    this.reimbursementErrorObj = null;
    this.isLoading = function () {
        return this.isLoadingReturnItems || this.isLoadingReimbursements;
    };
    this.reimburse = function () {
        var modalInstance = $uibModal.open({
            animation: false,
            component: 'simpleBoolModalComponent',
            resolve: { message: function () { return 'Are you sure to reimburse the customer?'; } }
        });
        modalInstance.result.then(function (val) {
            if (val) {
                $http
                    .post(API_BASE + "/customer_returns/" + vm.customerReturnId + "/reimbursements", {})
                    .then(onReimburseSuccess, onReimburseError);
                vm.isReimbursing = true;
            }
        });
    };
    loadReturnItems();
    loadReimbursements();
    function loadReturnItems() {
        $http
            .get(API_BASE + "/customer_returns/" + vm.customerReturnId + "/return_items")
            .then(onLoadReturnItemSuccess, onLoadReturnItemError);
    }
    function loadReimbursements() {
        $http
            .get(API_BASE + "/customer_returns/" + vm.customerReturnId + "/reimbursements")
            .then(onLoadReimbursementSuccess, onLoadReimbursementError);
    }
    function onLoadReturnItemSuccess(resp) {
        vm.isLoadingReturnItems = false;
        vm.returnItems = resp.data;
    }
    function onLoadReturnItemError(resp) {
        vm.isLoadingReturnItems = false;
        console.error(resp);
    }
    function onLoadReimbursementSuccess(resp) {
        vm.reimbursements = resp.data;
        vm.isLoadingReimbursements = false;
    }
    function onLoadReimbursementError(resp) {
        vm.isLoadingReimbursements = false;
        console.error(resp);
    }
    function onReimburseSuccess(resp) {
        vm.reimbursements.push(resp.data);
        vm.isReimbursing = false;
        vm.reimbursementErrorObj = null;
    }
    function onReimburseError(resp) {
        console.error(resp);
        vm.isReimbursing = false;
        vm.reimbursementErrorObj = resp.data;
    }
}
angular
    .module('app')
    .controller('CustomerReturn', CustomerReturnCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function OrderCustomerReturnsCtrl(API_BASE, OrderResource, $http, $routeParams, $uibModal) {
    var vm = this;
    this.orderNum = $routeParams.orderNum;
    this.isLoadingCustomerReturns = true;
    this.isLoadingOrder = true;
    this.customerReturns = [];
    this.order = OrderResource.get({ number: this.orderNum }, function () { return vm.isLoadingOrder = false; });
    this.hasShippedShipment = function () {
        if (!this.order.shipments) {
            return false;
        }
        return _.some(this.order.shipments, function (s) { return s.state === 'shipped'; });
    };
    this.hasCustomerReturn = function () {
        return this.customerReturns.length > 0;
    };
    this.createCustomerReturnUrl = function () {
        return "#/orders/" + this.orderNum + "/customer_returns/new";
    };
    this.trySendCustomerReturnEmail = function () {
        var modalInstance = $uibModal.open({
            animation: false,
            component: 'simpleBoolModalComponent',
            resolve: {
                title: function () { return 'Customer return'; },
                message: function () { return 'Are you sure to send customer return notification email?'; }
            }
        });
        modalInstance.result.then(function (val) { return val && sendCustomerReturnEmail(); });
    };
    loadCustomerReturns();
    function loadCustomerReturns() {
        $http
            .get(API_BASE + "/orders/" + vm.orderNum + "/customer_returns")
            .then(onLoadCustomerReturnSuccess, onLoadCustomerReturnError);
    }
    function onLoadCustomerReturnSuccess(resp) {
        vm.customerReturns = resp.data;
        vm.isLoadingCustomerReturns = false;
    }
    function onLoadCustomerReturnError(resp) {
        vm.isLoadingCustomerReturns = false;
    }
    function sendCustomerReturnEmail() {
        $http
            .put(API_BASE + "/orders/" + vm.orderNum + "/send_success_return_email", {});
    }
}
angular
    .module('app')
    .controller('OrderCustomerReturns', OrderCustomerReturnsCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function OrderCustomerCtrl(API_BASE, OrderResource, $http, $routeParams) {
    var _this = this;
    var vm = this;
    this.orderNum = $routeParams.orderNum;
    this.isLoading = true;
    this.isDeliveringInvoice = false;
    this.deliverInvoiceErrorObj = null;
    this.billAddressAttributes = [
        { label: 'Name', key: 'full_name' },
        { label: 'Email', key: 'email' },
        { label: 'Phone', key: 'phone' }
    ];
    this.shippingAddressAttributes = [
        { label: 'Name', key: 'full_name' },
        { label: 'Email', key: 'email' },
        { label: 'Phone', key: 'phone' }
    ];
    this.invoiceAttributes = [
        { label: 'Phone', key: 'phone' },
        { label: 'Company', key: 'company' },
        { label: 'Tax ID', key: 'tax_id' }
    ];
    this.ecpayInvoiceAttributes = [
        { label: 'Number', key: 'number' },
        { label: 'Name', key: 'customer_name' },
        { label: 'Address', key: 'address' },
        { label: 'Phone', key: 'phone' },
        { label: 'Email', key: 'email' },
        { label: 'Tax ID', key: 'tax_id' }
    ];
    this.order = OrderResource.get({ number: this.orderNum }, function () { return (_this.isLoading = false); });
    // paper invoice
    this.invoiceType = function () {
        if (!this.order.invoice) {
            return null;
        }
        switch (this.order.invoice.invoice_type) {
            case 0:
                return '捐贈發票';
            case 1:
                return '二聯式';
            case 2:
                return '三聯式';
        }
    };
    // paper invoice
    this.allowDeliverInvoice = function () {
        return this.order &&
            this.order.invoice &&
            this.order.invoice.delivered_at == null &&
            !this.isDeliveringInvoice;
    };
    // paper invoice
    this.deliverInvoice = function () {
        var _this = this;
        this.isDeliveringInvoice = true;
        this.deliverInvoiceErrorObj = null;
        $http
            .put(API_BASE + "/orders/" + this.orderNum + "/send_invoice", {})
            .then(onDeliverInvoiceSuccess, onDeliverInvoiceError)
            .finally(function () { return (_this.isDeliveringInvoice = false); });
    };
    // paper invoice
    function onDeliverInvoiceSuccess() {
        vm.order.invoice.delivered_at = new Date().toISOString();
    }
    // paper invoice
    function onDeliverInvoiceError(resp) {
        console.error(resp);
        vm.deliverInvoiceErrorObj = resp.data;
    }
}
angular
    .module('app')
    .controller('OrderCustomer', OrderCustomerCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function OrderPaymentsCtrl(API_BASE, OrderResource, $http, $routeParams) {
    var vm = this;
    this.orderNum = $routeParams.orderNum;
    this.isLoadingOrder = true;
    this.isLoadingRefunds = true;
    this.isCapturing = false;
    this.order = OrderResource.get({ number: this.orderNum }, function () { return vm.isLoadingOrder = false; });
    this.isLoading = function () {
        return this.isLoadingOrder || this.isLoadingRefunds;
    };
    this.shouldShowCaptureBtn = function (payment) {
        return payment.source.choose_payment === 'Credit' && payment.state === 'pending';
    };
    this.capture = function (payment) {
        if (!this.order || !this.order.number || !payment || !payment.number) {
            return;
        }
        var url = API_BASE + "/orders/" + this.orderNum + "/payments/" + payment.number + "/capture";
        $http
            .put(url, {})
            .then(onCaptureSuccess, onCaptureError);
        this.isCapturing = true;
    };
    loadRefunds();
    function onCaptureSuccess(resp) {
        vm.order = OrderResource.get({ number: vm.orderNum }, function () { return vm.isCapturing = false; });
    }
    function onCaptureError(resp) {
        onCaptureSuccess(resp);
    }
    function loadRefunds() {
        $http
            .get(API_BASE + "/orders/" + vm.orderNum + "/refunds")
            .then(onLoadRefundSuccess, onLoadRefundError);
        vm.isLoadingRefunds = true;
    }
    function onLoadRefundSuccess(resp) {
        vm.isLoadingRefunds = false;
        vm.refunds = resp.data;
    }
    function onLoadRefundError(resp) {
        vm.isLoadingRefunds = false;
        vm.refunds = [];
    }
}
angular
    .module('app')
    .controller('OrderPayments', OrderPaymentsCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function OrderRMAsCtrl(API_BASE, OrderResource, $http, $routeParams, $uibModal) {
    var vm = this;
    this.orderNum = $routeParams.orderNum;
    this.isLoadingRMA = true;
    this.isLoadingOrder = true;
    this.rmas = [];
    this.order = OrderResource.get({ number: this.orderNum }, function () { vm.isLoadingOrder = false; });
    this.hasShippedShipment = function () {
        if (!this.order.shipments) {
            return false;
        }
        return _.some(this.order.shipments, function (s) { return s.state === 'shipped'; });
    };
    this.hasReturnAuthorization = function () {
        return this.rmas.length > 0;
    };
    this.createRMAUrl = function () {
        return "#/orders/" + this.orderNum + "/rmas/new";
    };
    this.deleteRMA = function (rma) {
        var modalInstance = $uibModal.open({
            animation: false,
            component: 'simpleBoolModalComponent',
            resolve: {
                title: function () { return 'Delete RMA'; },
                message: function () { return 'Are you sure to delete it?'; }
            }
        });
        modalInstance.result.then(function (val) {
            if (val) {
                $http
                    .delete(API_BASE + "/orders/" + vm.orderNum + "/return_authorizations/" + rma.id)
                    .then(angular.noop, onDeleteRMAError);
                vm.rmas = _.filter(vm.rmas, function (_rma) { return _rma.id !== rma.id; });
            }
        });
    };
    this.trySendRmaTermsEmail = function () {
        var modalInstance = $uibModal.open({
            animation: false,
            component: 'simpleBoolModalComponent',
            resolve: {
                title: function () { return 'RMA terms'; },
                message: function () { return 'Are you sure to send RMA terms email to user?'; }
            }
        });
        modalInstance.result.then(function (val) { return val && sendRmaTermsEmail(); });
    };
    loadRMAs();
    function loadRMAs() {
        $http
            .get(API_BASE + "/orders/" + vm.orderNum + "/return_authorizations")
            .then(onLoadRMASuccess, onLoadRMAError);
    }
    function onLoadRMASuccess(resp) {
        vm.rmas = resp.data.return_authorizations;
        vm.isLoadingRMA = false;
    }
    function onLoadRMAError(resp) {
        vm.isLoadingRMA = false;
    }
    function onDeleteRMAError(resp) {
        var modalInstance = $uibModal.open({
            animation: false,
            component: 'simpleBoolModalComponent',
            resolve: { message: function () { return JSON.stringify(resp.data); } }
        });
        modalInstance.result.then();
    }
    function sendRmaTermsEmail() {
        $http
            .put(API_BASE + "/orders/" + vm.orderNum + "/send_return_terms_email", {});
    }
}
angular
    .module('app')
    .controller('OrderRMAs', OrderRMAsCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function OrderShipmentsCtrl(API_BASE, OrderResource, $http, $routeParams, $uibModal) {
    var vm = this;
    this.isLoadingOrder = true;
    this.isUpdatingShipment = false;
    this.updateShipmentErrorObj = null;
    this.orderNum = $routeParams.orderNum;
    this.order = OrderResource.get({ number: this.orderNum }, onLoadOrder);
    this.updateShipment = function (shipment) {
        var data = {
            shipment: {
                tracking: shipment.tracking
            }
        };
        $http
            .put(API_BASE + "/shipments/" + shipment.number, data)
            .then(onUpdateShipmentSuccess, onUpdateShipmentError);
        this.isUpdatingShipment = true;
        this.updateShipmentErrorObj = null;
    };
    this.ship = function (shipment) {
        $http
            .put(API_BASE + "/shipments/" + shipment.number + "/ship", {})
            .then(onShipSuccess, onShipError);
        this.isUpdatingShipment = true;
    };
    this.ezcatTrackingUrl = function (shipment) {
        if (shipment) {
            var ezcatUrl = "http://www.t-cat.com.tw/Inquire/TraceDetail.aspx";
            if (shipment.tempTracking) {
                return ezcatUrl + "?BillID=" + shipment.tempTracking;
            }
        }
        return null;
    };
    this.trySendFailedDeliveryMail = function () {
        $uibModal
            .open({
            animation: false,
            component: 'simpleBoolModalComponent',
            resolve: {
                title: function () { return 'Failed delivery'; },
                message: function () { return 'Are you sure to send failed delivery email to user?'; }
            }
        })
            .result
            .then(function (val) { return val && sendFailedDeliveryMail(); });
    };
    this.showFailedDeliveryBtn = function (shipment) {
        return shipment.state === 'shipped' && !shipment.delivered_at;
    };
    function onUpdateShipmentSuccess(resp) {
        vm.isUpdatingShipment = false;
        vm.updateShipmentErrorObj = null;
        if (vm.order) {
            angular.forEach(vm.order.shipments, function (shipment) {
                if (shipment.id === resp.data.id) {
                    angular.copy(resp.data, shipment);
                    shipment.tempTracking = resp.data.tracking;
                }
            });
        }
    }
    function onUpdateShipmentError(resp) {
        vm.isUpdatingShipment = false;
        vm.updateShipmentErrorObj = resp.data;
    }
    function onShipSuccess() {
        vm.isUpdatingShipment = false;
        vm.order = OrderResource.get({ number: vm.orderNum }, function () { vm.isUpdatingShipment = false; });
    }
    function onShipError(resp) {
        vm.isUpdatingShipment = false;
        vm.updateShipmentErrorObj = resp.data;
    }
    function sendFailedDeliveryMail() {
        var url = API_BASE + "/orders/" + vm.orderNum + "/send_failed_delivery_email";
        // for now, we don't care if email is sent successfully or not
        $http.put(url, {});
    }
    function onLoadOrder() {
        if (!vm.order) {
            return;
        }
        vm.isLoadingOrder = false;
        // for ezcatTrackingUrl()
        angular.forEach(vm.order.shipments, function (shipment) {
            shipment.tempTracking = shipment.tracking;
        });
    }
}
angular
    .module('app')
    .controller('OrderShipments', OrderShipmentsCtrl);

/// <reference path="../../../typings/index.d.ts" />
function OrdersCtrl(API_BASE, TOKEN, $http, $location) {
    var vm = this;
    this.orders = [];
    this.isLoading = true;
    this.onlyCompleted = true;
    this.apiPerPageOptions = [10, 20, 30, 40, 50];
    this.apiPerPage = this.apiPerPageOptions[0];
    this.currPage = 1;
    this.totalOrders = 0;
    this.showAdvancedOptions = false;
    this.query = {};
    this.isAllOrdersSelected = false;
    this.toggleAdvancedOptions = function () {
        this.showAdvancedOptions = !this.showAdvancedOptions;
    };
    this.changePage = function (_, page) {
        this.fetch(page);
    };
    this.fetch = function (pageNum) {
        vm.isLoading = true;
        $http(httpConfig(pageNum))
            .then(onFetchSuccess)
            .finally(function () { return vm.isLoading = false; });
    };
    this.onAllOrderSelectedChange = function () {
        angular.forEach(vm.orders, function (o) { return o.selected = vm.isAllOrdersSelected; });
    };
    this.anyOrderSelected = function () {
        return _.some(vm.orders, function (o) { return o.selected; });
    };
    this.getDownloadEzcatCsvLink = function () {
        var numbers = getSelectedOrderNumbers().join(',');
        return API_BASE + "/ezcat_shipments.csv?token=" + TOKEN + "&orders=" + numbers;
    };
    this.fetch(1);
    function httpConfig(pageNum) {
        var ret = {
            method: 'GET',
            url: API_BASE + "/orders",
            params: {
                per_page: vm.apiPerPage,
                page: pageNum,
                'q[s][0][name]': 'completed_at',
                'q[s][0][dir]': 'desc'
            }
        };
        ret.params = angular.extend(ret.params, vm.query);
        if (vm.onlyCompleted) {
            ret.params['q[state_eq]'] = 'complete';
        }
        return ret;
    }
    function onFetchSuccess(resp) {
        vm.orders = resp.data.orders;
        vm.currPage = resp.data.current_page;
        vm.totalOrders = vm.apiPerPage * resp.data.pages;
    }
    function getSelectedOrderNumbers() {
        return _.map(_.filter(vm.orders, function (o) { return o.selected; }), function (o) { return o.number; });
    }
}
angular
    .module('app')
    .controller('Orders', OrdersCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function UpdateRMACtrl(API_BASE, OrderResource, $http, $location, $routeParams, $uibModal) {
    var vm = this;
    this.orderNum = $routeParams.orderNum;
    this.rmaId = $routeParams.id;
    this.isLoadingRMA = true;
    this.isLoadingReturnItems = true;
    this.returnItems = [];
    this.isLoadingStockLocations = true;
    this.stockLocations = [];
    this.isLoadingReasons = true;
    this.reasons = [];
    this.isUpdatingRMA = false;
    this.rma = {
        return_items_attributes: [],
        stock_location_id: null,
        return_authorization_reason_id: null,
        memo: ''
    };
    this.updateRMAErrorObj = null;
    this.isLoading = function () {
        return this.isLoadingRMA ||
            this.isLoadingReturnItems ||
            this.isLoadingStockLocations ||
            this.isLoadingReasons;
    };
    this.updateRMA = function () {
        this.rma.memo = this.rma.memo.trim();
        this.isUpdatingRMA = true;
        var url = API_BASE + "/orders/" + this.orderNum + "/return_authorizations/" + this.rmaId;
        $http
            .put(url, { return_authorization: this.rma })
            .then(onUpdateRMASuccess, onUpdateRMAError);
    };
    this.canUpdateRMA = function () {
        var returnItems = this.rma.return_items_attributes;
        if (this.rma.stock_location_id == null) {
            return false;
        }
        if (this.rma.return_authorization_reason_id == null) {
            return false;
        }
        if (_.every(returnItems, function (ri) { return ri._destroy; })) {
            return false;
        }
        return _.every(returnItems, function (ri) {
            return (ri._destroy ||
                (ri.pre_tax_amount != null && ri.pre_tax_amount >= 0));
        });
    };
    this.trySendRmaNotificationEmail = function () {
        var modalInstance = $uibModal.open({
            animation: false,
            component: 'simpleBoolModalComponent',
            resolve: {
                title: function () { return 'RMA notification'; },
                message: function () { return 'Are you sure to send RMA notification email to user?'; }
            }
        });
        modalInstance.result.then(function (val) { return val && sendRmaNotificationEmail(); });
    };
    $http
        .get(API_BASE + "/orders/" + this.orderNum + "/return_authorizations/" + this.rmaId)
        .then(onLoadRMASuccess, onLoadRMAError);
    $http
        .get(API_BASE + "/orders/" + this.orderNum + "/return_authorizations/" + this.rmaId + "/return_items")
        .then(onLoadReturnItemSuccess, onLoadReturnItemError);
    $http
        .get(API_BASE + "/stock_locations", { params: { per_page: 100 } })
        .then(onLoadStockLocationSuccess, onLoadStockLocationError);
    $http
        .get(API_BASE + "/return_authorization_reasons")
        .then(onLoadReasonSuccess, onLoadReasonError);
    function onLoadRMASuccess(resp) {
        vm.rma.stock_location_id = resp.data.stock_location_id;
        vm.rma.return_authorization_reason_id = resp.data.return_authorization_reason_id;
        vm.rma.memo = resp.data.memo;
        vm.isLoadingRMA = false;
    }
    function onLoadRMAError(resp) {
        console.error(resp);
        $location.path("/orders/" + vm.orderNum + "/rmas");
    }
    function onLoadStockLocationSuccess(resp) {
        vm.isLoadingStockLocations = false;
        vm.stockLocations = resp.data.stock_locations;
    }
    function onLoadStockLocationError(resp) {
        this.isLoadingStockLocations = false;
        console.error(resp);
    }
    function onLoadReturnItemSuccess(resp) {
        vm.isLoadingReturnItems = false;
        vm.returnItems = resp.data;
        vm.rma.return_items_attributes = _.map(resp.data, function (ri) {
            return {
                id: ri.id,
                inventory_unit_id: ri.inventory_unit.id,
                _destroy: (ri.id == null) ? 1 : 0,
                pre_tax_amount: ri.pre_tax_amount
            };
        });
    }
    function onLoadReturnItemError(resp) {
        vm.isLoadingReturnItems = false;
        console.error(resp);
    }
    function onLoadReasonSuccess(resp) {
        vm.isLoadingReasons = false;
        vm.reasons = resp.data;
    }
    function onLoadReasonError(resp) {
        vm.isLoadingReasons = false;
        console.error(resp);
    }
    function onUpdateRMASuccess(resp) {
        $location.path("/orders/" + vm.orderNum + "/rmas");
    }
    function onUpdateRMAError(resp) {
        vm.isUpdatingRMA = false;
        vm.updateRMAErrorObj = resp.data;
        console.error(resp);
    }
    function sendRmaNotificationEmail() {
        $http
            .put(API_BASE + "/orders/" + vm.orderNum + "/send_authorized_return_email", {});
    }
}
angular
    .module('app')
    .controller('UpdateRMA', UpdateRMACtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function CreateProductCtrl(API_BASE, TOKEN, ProductResource, ShippingCategoryResource, Upload, $location) {
    var _this = this;
    var vm = this;
    var success = function (product) { return $location.path(product.editPath()); };
    var error = function (resp) { return _this.createErrorObj = resp.data.errors; };
    this.product = new ProductResource();
    this.shippingCategories = ShippingCategoryResource.query(function () {
        _this.product.shipping_category_id = _this.shippingCategories[0].id;
    });
    this.createErrorObj = null;
    this.fields = [
        {
            key: 'name',
            type: 'input',
            templateOptions: {
                label: 'Name',
                placeholder: 'required',
                required: true,
                description: 'Name is required'
            }
        },
        {
            key: 'price',
            type: 'input',
            templateOptions: {
                type: 'number',
                label: 'Master price',
                placeholder: 'required',
                required: true,
                description: 'Price should be greater than 0',
                min: 0
            }
        },
        {
            key: 'shipping_category_id',
            type: 'select',
            templateOptions: {
                label: 'Shipping category',
                required: true,
                description: 'Shipping category is required',
                options: this.shippingCategories,
                valueProp: 'id',
                labelProp: 'name'
            }
        },
        {
            key: 'sku',
            type: 'input',
            templateOptions: {
                label: 'SKU',
                required: false
            }
        }
    ];
    this.csvFile = null;
    this.isImporting = false;
    this.badImportResults = [];
    this.importErrorObj = null;
    this.onSubmit = function () {
        ProductResource.save({ product: this.product.toJSON() }, success, error);
    };
    this.templateCsvUrl = function () {
        return API_BASE + "/product_importers/template.csv?token=" + TOKEN;
    };
    this.import = function () {
        this.isImporting = true;
        this.badImportResults = [];
        this.importErrorObj = null;
        Upload
            .upload({
            url: API_BASE + "/product_importers",
            data: { file: this.csvFile }
        })
            .then(onImportSuccess, onImportError);
    };
    function onImportSuccess(resp) {
        vm.badImportResults = _.filter(resp.data, function (r) { return !r.success; });
        if (vm.badImportResults.length === 0) {
            $location.path('/products');
        }
    }
    function onImportError(resp) {
        console.error(resp);
        vm.isImporting = false;
        vm.importErrorObj = resp.data;
    }
}
angular
    .module('app')
    .controller('CreateProduct', CreateProductCtrl);

/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../modules/api/product.ts" />
/// <reference path="../modules/resource/picture.ts" />
"use strict";
function ProductImagesCtrl(API_BASE, ProductResource, $location, $routeParams, $http, $q, $uibModal) {
    var PICTURE_TYPES = [
        { name: 'Base image', value: 'PRODUCT_BASE' },
        { name: 'Media image', value: 'PRODUCT_MEDIA' }
    ];
    var vm = this;
    this.product = ProductResource.get({ id: $routeParams.productId, show_deleted: 1, show_discontinued: 1 }, onFetchProduct);
    this.pictures = [];
    this.errorObj = null;
    this.isSaving = false;
    this.isUploading = false;
    this.sortableOptions = { stop: function () { return resetPicturePosition(); } };
    this.newPictures = [];
    this.deleteQueue = [];
    this.picFields = [
        {
            key: 'type',
            type: 'select',
            templateOptions: {
                required: true,
                options: PICTURE_TYPES,
                valueProp: 'value',
                labelProp: 'name'
            }
        },
        {
            key: 'alt',
            type: 'input',
            templateOptions: {
                placeholder: 'Alt text'
            }
        }
    ];
    this.save = function () {
        var promises = [];
        angular.forEach(this.deleteQueue, function (pic) {
            promises.push($http.delete(API_BASE + "/pictures/" + pic.id));
        });
        angular.forEach(this.pictures, function (pic) {
            var body = {
                picture: { alt: pic.alt.trim(), position: pic.position, type: pic.type }
            };
            promises.push($http.put(API_BASE + "/pictures/" + pic.id, body));
        });
        $q
            .all(promises)
            .then(onSaveSuccess, onSaveError);
        vm.errorObj = null;
        vm.isSaving = true;
    };
    this.delete = function (pic) {
        this.deleteQueue.push(pic);
        this.pictures = this.pictures.filter(function (p) { return p.id !== pic.id; });
    };
    this.openCreateImageModal = function () {
        var modalInstance = $uibModal.open({
            animation: false,
            component: 'createProductImageComponent'
        });
        modalInstance.result.then(uploadImages);
    };
    this.onCreate = function (createResp) {
        this.product.master.pictures.push(createResp.data);
        onFetchProduct(this.product);
    };
    this.onComplete = function () {
        vm.isUploading = false;
    };
    function onFetchProduct(product) {
        var pictureSet = {};
        var scanPictures = function (pictures) {
            angular.forEach(pictures, function (pic) { pictureSet[pic.id] = pic; });
        };
        if (product.master && product.master.pictures) {
            scanPictures(product.master.pictures);
        }
        if (product.variants) {
            angular.forEach(product.variants, function (variant) {
                if (variant.pictures) {
                    scanPictures(variant.pictures);
                }
            });
        }
        var pics = [];
        angular.forEach(pictureSet, function (pic) { return pics.push(pic); });
        pics = pics.sort(function (p1, p2) { return p1.position - p2.position; });
        vm.pictures = angular.forEach(pics, function (pic) {
            angular.extend(pic, gladiator.resource.Picture.prototype);
        });
    }
    function resetPicturePosition() {
        angular.forEach(vm.pictures, function (val, index) { return val.position = index + 1; });
    }
    function onSaveSuccess() {
        $location.path(vm.product.editPath());
    }
    function onSaveError(resp) {
        console.error(resp);
        vm.errorObj = resp.data;
        vm.isSaving = false;
    }
    function uploadImages(files) {
        if (files.length === 0) {
            return;
        }
        vm.isUploading = true;
        vm.newPictures = files;
        vm.errorObj = null;
    }
}
angular
    .module('app')
    .controller('ProductImages', ProductImagesCtrl);

/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../modules/api/product.ts" />
/// <reference path="../modules/resource/picture.ts" />
"use strict";
var PropertyStatus;
(function (PropertyStatus) {
    PropertyStatus[PropertyStatus["CLEAN"] = 0] = "CLEAN";
    PropertyStatus[PropertyStatus["DIRTY"] = 1] = "DIRTY";
    PropertyStatus[PropertyStatus["NEW"] = 2] = "NEW";
    PropertyStatus[PropertyStatus["DELETED"] = 3] = "DELETED";
})(PropertyStatus || (PropertyStatus = {}));
var Property = (function () {
    function Property(opt) {
        var _this = this;
        angular.forEach(['id', 'property_name', 'value', 'position', 'status'], function (attr) { return _this[attr] = opt[attr]; });
    }
    Property.prototype.new = function () {
        this.property_name = this.value = '';
        this.position = (new Date()).getTime() / 1000;
        this.status = PropertyStatus.NEW;
    };
    Property.prototype.delete = function () {
        this.status = PropertyStatus.DELETED;
    };
    Property.prototype.dirty = function () {
        if (this.status === PropertyStatus.CLEAN) {
            this.status = PropertyStatus.DIRTY;
        }
    };
    Property.prototype.shouldDisplay = function () {
        return this.status !== PropertyStatus.DELETED;
    };
    Property.prototype.upsertBody = function () {
        return {
            product_property: {
                property_name: this.property_name.trim(),
                value: this.value.trim(),
                position: this.position
            },
            show_deleted: 1,
            show_discontinued: 1
        };
    };
    Property.prototype.deleteBody = function () {
        return { show_deleted: 1, show_discontinued: 1 };
    };
    Property.prototype.hasName = function () {
        return this.property_name.trim().length > 0;
    };
    Property.prototype.changePosition = function (pos) {
        if (pos === this.position) {
            return;
        }
        this.position = pos;
        this.dirty();
    };
    return Property;
}());
function ProductPropertiesCtrl(API_BASE, ProductResource, $location, $routeParams, $http, $q) {
    var vm = this;
    this.product = ProductResource.get({ id: $routeParams.productId, show_deleted: 1, show_discontinued: 1 }, onFetchProduct);
    this.properties = [];
    this.sortableOptions = { stop: function () { return resetPosition(); } };
    this.isSaving = false;
    this.errorObj = null;
    this.addProperty = function () {
        var property = new Property({});
        property.new();
        this.properties.push(property);
        resetPosition();
    };
    this.save = function () {
        var promises = [];
        var createUrl = API_BASE + "/products/" + this.product.id + "/product_properties";
        angular.forEach(this.properties, function (p) {
            if (p.status === PropertyStatus.CLEAN) {
                return;
            }
            else if (p.status === PropertyStatus.NEW && p.hasName()) {
                promises.push($http.post(createUrl, p.upsertBody()));
            }
            else if (p.status === PropertyStatus.DELETED && p.id) {
                // $http.delete does not send body
                promises.push($http({
                    method: 'DELETE',
                    url: createUrl + "/" + p.id,
                    data: p.deleteBody(),
                    headers: { 'Content-Type': 'application/json;charset=utf-8' }
                }));
            }
            else if (p.status === PropertyStatus.DIRTY && p.id && p.hasName()) {
                promises.push($http.put(createUrl + "/" + p.id, p.upsertBody()));
            }
        });
        $q.all(promises).then(onSaveSuccess, onSaveError);
        vm.isSaving = true;
        vm.errorObj = null;
    };
    function onFetchProduct() {
        vm.properties = vm.product.product_properties.map(function (pp) {
            var p = angular.extend({}, pp, { status: PropertyStatus.CLEAN });
            return new Property(p);
        });
    }
    function resetPosition() {
        angular.forEach(vm.properties, function (val, index) { return val.changePosition(index + 1); });
    }
    function onSaveSuccess() {
        $location.path(vm.product.editPath());
    }
    function onSaveError(resp) {
        vm.isSaving = false;
        vm.errorObj = resp;
    }
}
angular
    .module('app')
    .controller('ProductProperties', ProductPropertiesCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function ProductStocksCtrl(API_BASE, ProductResource, $http, $location, $routeParams) {
    var vm = this;
    this.product = ProductResource.get({ id: $routeParams.productId, show_deleted: 1, show_discontinued: 1 }, onLoadProduct);
    this.stockLocations = [];
    this.stockChange = {};
    this.stockFields = [
        {
            key: 'quantity',
            type: 'input',
            templateOptions: {
                type: 'number',
                required: true,
                label: 'Quantity',
                description: 'Quantity should be a valid integer'
            }
        },
        {
            key: 'stockLocationId',
            type: 'select',
            templateOptions: {
                label: 'Stock location',
                required: true,
                options: [],
                valueProp: 'id',
                labelProp: 'name'
            }
        },
        {
            key: 'variantId',
            type: 'select',
            templateOptions: {
                label: 'Variant',
                required: true,
                options: [],
                valueProp: 'id',
                labelProp: 'name'
            }
        }
    ];
    this.isAddingStock = false;
    this.addStockErrorObj = null;
    this.countOnHand = 0;
    this.addStock = function () {
        var url = API_BASE + "/stock_locations/" + vm.stockChange.stockLocationId + "/stock_items/add_stock";
        var payload = {
            quantity: vm.stockChange.quantity,
            variant_id: vm.stockChange.variantId
        };
        vm.isAddingStock = true;
        vm.addStockErrorObj = null;
        $http
            .post(url, payload)
            .then(function (resp) { return onAddStockSuccess(resp.data); }, function (resp) { return onAddStockError(resp.data); });
    };
    $http
        .get(API_BASE + "/stock_locations", { params: { per_page: 100 } })
        .then(function (resp) { return onLoadStockLocations(resp.data.stock_locations); });
    function onLoadProduct(product) {
        if (product.has_variants) {
            vm.stockFields[2].templateOptions.options = product.variants;
        }
        else {
            vm.stockFields[2].templateOptions.options = [product.master];
        }
        vm.stockChange.variantId = vm.stockFields[2].templateOptions.options[0].id;
        vm.countOnHand = product.total_on_hand;
    }
    function onLoadStockLocations(stockLocations) {
        vm.stockLocations = stockLocations;
        vm.stockFields[1].templateOptions.options = stockLocations;
        vm.stockChange.stockLocationId = stockLocations[0].id;
    }
    function onAddStockSuccess(resp) {
        vm.isAddingStock = false;
        vm.countOnHand = resp.count_on_hand;
    }
    function onAddStockError(resp) {
        vm.isAddingStock = false;
        vm.addStockErrorObj = resp;
    }
}
angular
    .module('app')
    .controller('ProductStocks', ProductStocksCtrl);

/// <reference path="../../../typings/index.d.ts" />
"use strict";
function ProductsCtrl(API_BASE, $http, ProductResource) {
    var vm = this;
    this.products = [];
    this.isLoading = true;
    this.showDeleted = false;
    this.showDiscontinued = false;
    this.apiPerPageOptions = [10, 20, 30, 40, 50];
    this.apiPerPage = this.apiPerPageOptions[0];
    this.currPage = 1;
    this.totalProducts = 0;
    this.changePage = function (_, page) {
        this.fetch(page);
    };
    this.fetch = function (pageNum) {
        vm.isLoading = true;
        $http(httpConfig(pageNum))
            .then(onFetchSuccess)
            .finally(function () { return vm.isLoading = false; });
    };
    this.fetch(1);
    function httpConfig(pageNum) {
        var ret = {
            method: 'GET',
            url: API_BASE + "/products",
            params: {
                per_page: vm.apiPerPage,
                page: pageNum,
                'q[s][0][name]': 'id',
                'q[s][0][dir]': 'desc'
            }
        };
        if (vm.showDeleted) {
            ret.params.show_deleted = true;
        }
        if (vm.showDiscontinued) {
            ret.params.show_discontinued = true;
        }
        return ret;
    }
    function onFetchSuccess(resp) {
        vm.products = resp.data.products.map(function (p) { return new ProductResource(p); });
        vm.currPage = resp.data.current_page;
        vm.totalProducts = resp.data.total_count;
    }
}
angular
    .module('app')
    .controller('Products', ProductsCtrl);

/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../modules/api/product.ts" />
"use strict";
function UpdateProductCtrl(API_BASE, ProductResource, ShippingCategoryResource, $location, $routeParams, $http) {
    var _this = this;
    var success = function () { return $location.path('/products'); };
    var error = function (resp) {
        _this.errorObj = resp.data.errors;
        _this.isSaving = false;
    };
    var vm = this;
    this.isSaving = false;
    this.defaultMediaImage = 'holder.js/300x400?text=N/A&auto=yes';
    this.product = ProductResource.get({ id: $routeParams.productId, show_deleted: 1, show_discontinued: 1 }, onFetchProduct);
    this.shippingCategories = ShippingCategoryResource.query();
    this.errorObj = null;
    this.basicFields = [
        {
            key: 'name',
            type: 'input',
            templateOptions: {
                label: 'Name',
                placeholder: 'required',
                required: true,
                description: 'Name is required'
            }
        },
        {
            key: 'shipping_category_id',
            type: 'select',
            templateOptions: {
                label: 'Shipping category',
                required: true,
                description: 'Shipping category is required',
                options: this.shippingCategories,
                valueProp: 'id',
                labelProp: 'name'
            }
        },
        {
            key: 'price',
            type: 'input',
            ngModelElAttrs: {
                'string-to-number': ''
            },
            templateOptions: {
                type: 'number',
                label: 'Master price',
                placeholder: 'required',
                required: true,
                description: 'Price should be greater than 0',
                min: 0
            }
        }
    ];
    this.dateFields = [
        {
            key: 'available_on',
            type: 'input',
            ngModelElAttrs: {
                'string-to-date': ''
            },
            templateOptions: {
                type: 'datetime-local',
                label: 'Available on',
                placeholder: 'yyyy-MM-ddTHH:mm:ss',
                required: false,
                description: 'Incorrect date'
            }
        },
        {
            key: 'discontinue_on',
            type: 'input',
            ngModelElAttrs: {
                'string-to-date': ''
            },
            templateOptions: {
                type: 'datetime-local',
                label: 'Discontinue on',
                placeholder: 'yyyy-MM-ddTHH:mm:ss',
                required: false,
                description: 'Incorrect date'
            }
        }
    ];
    this.skuField = [
        {
            key: 'sku',
            type: 'input',
            templateOptions: {
                label: 'SKU',
                required: false
            }
        }
    ];
    this.volumeFields = [
        {
            key: 'weight',
            type: 'input',
            ngModelElAttrs: {
                'string-to-number': ''
            },
            templateOptions: {
                type: 'number',
                label: 'Weight',
                required: false,
                description: 'Invalid weight',
                min: 0
            }
        },
        {
            key: 'width',
            type: 'input',
            ngModelElAttrs: {
                'string-to-number': ''
            },
            templateOptions: {
                type: 'number',
                label: 'Width',
                required: false,
                description: 'Invalid width',
                min: 0
            }
        },
        {
            key: 'height',
            type: 'input',
            ngModelElAttrs: {
                'string-to-number': ''
            },
            templateOptions: {
                type: 'number',
                label: 'Height',
                required: false,
                description: 'Invalid height',
                min: 0
            }
        },
        {
            key: 'depth',
            type: 'input',
            ngModelElAttrs: {
                'string-to-number': ''
            },
            templateOptions: {
                type: 'number',
                label: 'Depth',
                required: false,
                description: 'Invalid depth',
                min: 0
            }
        }
    ];
    this.mediaFields = [
        {
            key: 'image',
            type: 'input',
            templateOptions: {
                type: 'url',
                label: 'Image',
                required: false,
                description: 'Invalid image url',
                placeholder: 'https://api.thekono.com/KPI2/magazines/:bid/cover'
            }
        },
        {
            key: 'quote',
            type: 'input',
            templateOptions: {
                label: 'Quote',
                required: false
            }
        },
        {
            key: 'source',
            type: 'input',
            templateOptions: {
                label: 'Source',
                required: false
            }
        },
        {
            key: 'link',
            type: 'input',
            templateOptions: {
                label: 'Link',
                required: false
            }
        }
    ];
    this.descriptionFields = [
        {
            key: 'description_heading',
            type: 'input',
            templateOptions: {
                label: 'Heading',
                required: false
            }
        },
        {
            key: 'description_body',
            type: 'textarea',
            templateOptions: {
                label: 'Body',
                required: false,
                rows: 3
            }
        }
    ];
    this.furtherReadingFields = [
        {
            key: 'url',
            type: 'input',
            templateOptions: {
                type: 'url',
                label: 'Further reading',
                required: false,
                description: 'Invalid url'
            }
        }
    ];
    this.seoFields = [
        {
            key: 'meta_title',
            type: 'input',
            templateOptions: {
                label: 'Meta title',
                required: false
            }
        },
        {
            key: 'meta_keywords',
            type: 'input',
            templateOptions: {
                label: 'Meta keywords',
                required: false
            }
        },
        {
            key: 'meta_description',
            type: 'input',
            templateOptions: {
                label: 'Meta description',
                required: false
            }
        }
    ];
    this.addSellingPoint = function () {
        if (this.product && this.product.selling_points) {
            this.product.selling_points.push({ text: '' });
        }
    };
    this.addAttention = function () {
        if (this.product && this.product.attentions) {
            this.product.attentions.push({ text: '' });
        }
    };
    this.saveProduct = function () {
        var _this = this;
        var url = API_BASE + "/products/" + this.product.id;
        var data = {
            product: {
                selling_points: this.product.selling_points.filter(function (sp) { return sp.text.trim().length > 0; }),
                attentions: this.product.attentions.filter(function (a) { return a.text.trim().length > 0; }),
                media: this.product.media.filter(
                // if image, source, quote are empty, ignore it
                function (m) { return [m.image, m.quote, m.source, m.link].join('').trim().length > 0; }),
                further_readings: this.product.further_readings.filter(function (fr) { return fr.url.trim().length > 0; })
            },
            show_deleted: 1,
            show_discontinued: 1
        };
        angular.forEach([
            'name', 'price', 'shipping_category_id', 'available_on',
            'discontinue_on', 'description_heading', 'description_body',
            'meta_title', 'meta_keywords', 'meta_description'
        ], function (key) { return data.product[key] = _this.product[key]; });
        angular.forEach(['sku', 'weight', 'width', 'height', 'depth'], function (key) { return data.product[key] = _this.product.master[key]; });
        /**
         * Avoid rails deep_munge bug
         * http://guides.rubyonrails.org/security.html#unsafe-query-generation
         */
        var attrs = ['selling_points', 'attentions', 'media', 'further_readings'];
        angular.forEach(attrs, function (attr) {
            if (data.product[attr].length === 0) {
                data.product[attr] = [''];
            }
        });
        return $http.put(url, data).then(success, error);
    };
    this.save = function () {
        if (this.product && this.product.id) {
            this.isSaving = true;
            this.saveProduct();
        }
    };
    function onFetchProduct(product) {
        initProductMedia(product);
        initProductFurtherReading(product);
    }
    function initProductMedia(product) {
        if (product.media && product.media[0]) {
            return;
        }
        product.media = [{ image: '', source: '', quote: '' }];
        return product;
    }
    function initProductFurtherReading(product) {
        if (product.further_readings && product.further_readings[0]) {
            return;
        }
        product.further_readings = [{ url: '' }];
        return product;
    }
}
angular
    .module('app')
    .controller('UpdateProduct', UpdateProductCtrl);

/// <reference path="../../../typings/index.d.ts" />
function CreatePromotionCtrl(API_BASE, $http, $location) {
    var vm = this;
    this.promotion = {};
    this.createErrorObj = null;
    this.isCreating = false;
    this.create = function () {
        var _this = this;
        this.isCreating = true;
        this.createErrorObj = null;
        $http
            .post(API_BASE + "/promotions", { promotion: this.promotion })
            .then(onCreateSuccess, onCreateError)
            .finally(function () { return _this.isCreating = false; });
    };
    function onCreateSuccess(resp) {
        var promotionId = resp.data.id;
        $location.path("/promotions/" + promotionId);
    }
    function onCreateError(resp) {
        this.createErrorObj = resp.data;
        console.error(resp);
    }
}
angular
    .module('app')
    .controller('CreatePromotion', CreatePromotionCtrl);

/// <reference path="../../../typings/index.d.ts" />
function PromotionsCtrl(API_BASE, $http, $location) {
    var vm = this;
    this.promotions = [];
    this.isLoading = true;
    this.apiPerPageOptions = [10, 20, 30, 40, 50];
    this.apiPerPage = this.apiPerPageOptions[0];
    this.currPage = 1;
    this.totalPromotions = 0;
    this.showAdvancedOptions = false;
    this.query = {};
    this.toggleAdvancedOptions = function () {
        this.showAdvancedOptions = !this.showAdvancedOptions;
    };
    this.changePage = function (_, page) {
        this.fetch(page);
    };
    this.fetch = function (pageNum) {
        vm.isLoading = true;
        $http(httpConfig(pageNum))
            .then(onFetchSuccess)
            .finally(function () { return vm.isLoading = false; });
    };
    this.fetch(1);
    function httpConfig(pageNum) {
        var ret = {
            method: 'GET',
            url: API_BASE + "/promotions",
            params: {
                per_page: vm.apiPerPage,
                page: pageNum,
                'q[s][0][name]': 'id',
                'q[s][0][dir]': 'desc'
            }
        };
        ret.params = angular.extend(ret.params, vm.query);
        return ret;
    }
    function onFetchSuccess(resp) {
        vm.promotions = resp.data.promotions;
        vm.currPage = resp.data.current_page;
        vm.totalPromotions = resp.data.total_count;
    }
}
angular
    .module('app')
    .controller('Promotions', PromotionsCtrl);

/// <reference path="../../../typings/index.d.ts" />
function UpdatePromotionCtrl(API_BASE, $http, $location, $routeParams) {
    var ALL_RULE_TYPES = [
        { name: 'Item total', type: 'Spree::Promotion::Rules::ItemTotal' },
        { name: 'First order', type: 'Spree::Promotion::Rules::FirstOrder' },
        { name: 'One use per user', type: 'Spree::Promotion::Rules::OneUsePerUser' }
    ];
    var ALL_ACTION_TYPES = [
        {
            name: 'Create whole-order adjustment',
            type: 'Spree::Promotion::Actions::CreateAdjustment'
        },
        { name: 'Free shipping', type: 'Spree::Promotion::Actions::FreeShipping' }
    ];
    var vm = this;
    this.promotionId = $routeParams.id;
    this.promotion = null;
    this.updateErrorObj = null;
    this.isSaving = false;
    this.newRuleType = null;
    this.newActionType = null;
    this.availableRuleTypes = function () {
        var existingRuleTypeLut = {};
        _.each(vm.promotion.promotion_rules, function (r) { return r._destroy || (existingRuleTypeLut[r.type] = true); });
        return _.reject(ALL_RULE_TYPES, function (rt) { return existingRuleTypeLut[rt.type]; });
    };
    this.availableActionTypes = function () {
        var existingActionTypeLut = {};
        _.each(vm.promotion.promotion_actions, function (a) { return a._destroy || (existingActionTypeLut[a.type] = true); });
        return _.reject(ALL_ACTION_TYPES, function (at) { return existingActionTypeLut[at.type]; });
    };
    this.addRule = function (type) {
        if (!this.promotion || !this.promotion.promotion_rules) {
            return;
        }
        var rule = { type: type };
        if (type === 'Spree::Promotion::Rules::ItemTotal') {
            var itRule = rule;
            itRule.preferred_amount_max = '1000';
            itRule.preferred_amount_min = '100';
            itRule.preferred_operator_max = 'lt';
            itRule.preferred_operator_min = 'gt';
        }
        this.promotion.promotion_rules.push(rule);
    };
    this.addAction = function (type) {
        if (!this.promotion || !this.promotion.promotion_actions) {
            return;
        }
        var action = { type: type };
        if (type === 'Spree::Promotion::Actions::CreateAdjustment') {
            action.calculator = {
                type: 'Spree::Calculator::FlatRate',
                preferred_amount: '100'
            };
        }
        this.promotion.promotion_actions.push(action);
    };
    this.save = function () {
        var _this = this;
        this.isSaving = true;
        this.updateErrorObj = null;
        $http
            .put(API_BASE + "/promotions/" + this.promotion.id, makePromotionApiPayload())
            .then(onSaveSuccess, onSaveError)
            .finally(function () { return _this.isSaving = false; });
    };
    loadPromotion();
    function loadPromotion() {
        $http
            .get(API_BASE + "/promotions/" + vm.promotionId)
            .then(onLoadSuccess, onLoadError);
    }
    function onLoadSuccess(resp) {
        vm.promotion = resp.data;
    }
    function onLoadError(resp) {
        vm.promotion = {};
        console.error(resp);
    }
    function removeHiddenPromotionRules() {
        vm.promotion.promotion_rules = _.reject(vm.promotion.promotion_rules, function (rule) { return rule._destroy && rule.id == null; });
    }
    function removeHiddenPromotionActions() {
        vm.promotion.promotion_actions = _.reject(vm.promotion.promotion_actions, function (action) {
            return action._destroy && action.id == null;
        });
    }
    function makePromotionApiPayload() {
        var ret = {
            promotion_rules_attributes: [],
            promotion_actions_attributes: []
        };
        ret.name = vm.promotion.name.trim();
        ret.description = vm.promotion.description && vm.promotion.description.trim();
        ret.code = vm.promotion.code && vm.promotion.code.trim();
        ret.usage_limit = vm.promotion.usage_limit;
        ret.starts_at = vm.promotion.starts_at;
        ret.expires_at = vm.promotion.expires_at;
        ret.match_policy = vm.promotion.match_policy;
        removeHiddenPromotionRules();
        removeHiddenPromotionActions();
        _.each(vm.promotion.promotion_rules, function (r) {
            if (r.type) {
                ret.promotion_rules_attributes.push(r);
            }
        });
        _.each(vm.promotion.promotion_actions, function (a) {
            var action = angular.copy(a);
            if (action.calculator && !_.isEmpty(action.calculator)) {
                action.calculator_attributes = angular.copy(action.calculator);
                delete action.calculator;
            }
            if (action.type) {
                ret.promotion_actions_attributes.push(action);
            }
        });
        return { promotion: ret };
    }
    function onSaveSuccess() {
        $location.path("/promotions");
    }
    function onSaveError(resp) {
        console.error(resp);
        vm.updateErrorObj = resp.data;
    }
}
angular
    .module('app')
    .controller('UpdatePromotion', UpdatePromotionCtrl);

/// <reference path="../../../typings/index.d.ts" />
function UpdateUserCtrl(API_BASE, $http, $routeParams) {
    var vm = this;
    this.isLoading = true;
    this.userId = $routeParams.id;
    this.user = null;
    loadUser(this.userId);
    function loadUser(userId) {
        vm.isLoading = true;
        $http
            .get(API_BASE + "/users/" + userId)
            .then(onLoadUser);
    }
    function onLoadUser(resp) {
        vm.user = resp.data;
        vm.isLoading = false;
    }
}
angular
    .module('app')
    .controller('UpdateUser', UpdateUserCtrl);

/// <reference path="../../../typings/index.d.ts" />
function UsersCtrl(API_BASE, $http) {
    var vm = this;
    this.users = [];
    this.isLoading = true;
    this.apiPerPageOptions = [10, 20, 30, 40, 50];
    this.apiPerPage = this.apiPerPageOptions[0];
    this.currPage = 1;
    this.totalUsers = 0;
    this.showAdvancedOptions = false;
    this.query = {};
    this.toggleAdvancedOptions = function () {
        this.showAdvancedOptions = !this.showAdvancedOptions;
    };
    this.changePage = function (_, page) {
        this.fetch(page);
    };
    this.fetch = function (pageNum) {
        vm.isLoading = true;
        $http(httpConfig(pageNum))
            .then(onFetchSuccess)
            .finally(function () { return vm.isLoading = false; });
    };
    this.fetch(1);
    function httpConfig(pageNum) {
        var ret = {
            method: 'GET',
            url: API_BASE + "/users",
            params: {
                per_page: vm.apiPerPage,
                page: pageNum
            }
        };
        ret.params = angular.extend(ret.params, vm.query);
        return ret;
    }
    function onFetchSuccess(resp) {
        vm.users = resp.data.users;
        vm.currPage = resp.data.current_page;
        vm.totalUsers = resp.data.total_count;
    }
}
angular
    .module('app')
    .controller('Users', UsersCtrl);
